// import React, { useState, useEffect } from "react";
// import "./electricianOrderForm.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";

// const ElectricianOrderForm = ({ user, formData, onClose, serviceId }) => {
//   const [orderData, setOrderData] = useState({
//     city: user?.city || "",
//     address: user?.Address || "",
//     mobile: user?.mobile || "",
//   });
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showForm, setShowForm] = useState(true);

//   // Compute penalty and final price (base price + penalty)
//   const penalty = user && user.penalty ? Number(user.penalty) : 0;
//   console.log("use penalty", penalty);
//   // const basePrice = Number(formData.price) || 0;
//   // const finalPrice = basePrice + penalty;
//   // const finalPrice = user.penaltyReserved ? basePrice : basePrice + (user.penalty ? Number(user.penalty) : 0);
//   const basePrice = Number(formData.price) || 0;
//   const finalPrice = user.penaltyReserved
//     ? basePrice
//     : basePrice + (user.penalty ? Number(user.penalty) : 0);

//   useEffect(() => {
//     if (user) {
//       setOrderData({
//         city: user.city || "",
//         address: user.Address || "",
//         mobile: user.mobile || "",
//       });
//     }
//   }, [user]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setOrderData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const finalOrderData = {
//       userId: user.Id,
//       usercity: orderData.city,
//       useraddress: orderData.address,
//       fanInstall: formData.fanInstall,
//       lightInstall: formData.lightInstall,
//       fanRepair: formData.fanRepair,
//       lightRepair: formData.lightRepair,
//       switchBoardRepair: formData.switchBoardRepair,
//       distributionBoardServicing: formData.distributionBoardServicing,
//       mcbServicing: formData.mcbServicing,
//       price: formData.price,
//       // price: finalPrice,
//       date: formData.date,
//       time: formData.time,
//       status: "pending",
//       servitor_id: 0,
//       serviceId: 1,
//     };

//     try {
//       const response = await axios.post(
//         "http://localhost:4001/electrician",
//         finalOrderData
//       );
//       console.log("Order placed successfully:", response.data);
//       setShowForm(false);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error placing order:", error);
//     }
//   };

//   const closePopup = () => {
//     setShowSuccessPopup(false);
//     onClose();
//   };

//   return (
//     <>
//       {showForm && (
//         <div className="electricianorder-modal">
//           <div className="electricianorder-overlay" onClick={onClose}></div>
//           <div className="electricianorder-form-container">
//             <div className="electricianorder-form-header">
//               <div className="header-content">
//                 <h2>Order Details</h2>
//               </div>
//               <button className="close-button" onClick={onClose}>
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>
//             <hr />
//             <div className="electricianorder-form-content">
//               <div className="electricianorder-left">
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Name</label>
//                     <input
//                       type="text"
//                       value={`${user.FirstName} ${user.LastName}`}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Mobile</label>
//                     <input
//                       type="text"
//                       value={"0" + orderData.mobile}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>City</label>
//                     <select
//                       id="city"
//                       name="city"
//                       value={orderData.city}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select your City</option>
//                       <option value="Dhaka">Dhaka</option>
//                       <option value="Chattogram">Chattogram</option>
//                       <option value="Barishal">Barishal</option>
//                       <option value="Sylhet">Sylhet</option>
//                       <option value="Rajshahi">Rajshahi</option>
//                       <option value="Khulna">Khulna</option>
//                       <option value="Rangpur">Rangpur</option>
//                       <option value="Maymensingh">Maymensingh</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Address</label>
//                     <input
//                       type="text"
//                       name="address"
//                       value={orderData.address}
//                       onChange={handleChange}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="electricianorder-right">
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Fan Install/Uninstall</label>
//                     <input type="text" value={formData.fanInstall} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Light Install/Uninstall</label>
//                     <input type="text" value={formData.lightInstall} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Fan Repair</label>
//                     <input type="text" value={formData.fanRepair} readOnly />
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Light Repair</label>
//                     <input type="text" value={formData.lightRepair} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Switch Board Repair</label>
//                     <input
//                       type="text"
//                       value={formData.switchBoardRepair}
//                       readOnly
//                     />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>MDB Servicing</label>
//                     <input
//                       type="text"
//                       value={formData.distributionBoardServicing}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>MCB Servicing</label>
//                     <input type="text" value={formData.mcbServicing} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Date</label>
//                     <input type="date" value={formData.date} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Time</label>
//                     <input type="text" value={formData.time} readOnly />
//                   </div>
//                 </div>
//                 {/* <div className="electricianorder-row">
//                                     <div className="electricianorder-col">
//                                         <label>Total Price</label>
//                                         <input type="text" value={`${formData.price} tk`} readOnly />
//                                         <input type="text" value={`${finalPrice} tk`} readOnly />
//                                     </div>
//                                 </div> */}
//                 <div className="electricianorder-row">
//                   {!user.penaltyReserved && penalty > 0 ? (
//                     <>
//                       <div className="electricianorder-col">
//                         <label>Base Price</label>
//                         <input type="text" value={`${basePrice} tk`} readOnly />
//                       </div>
//                       <div className="electricianorder-col">
//                         <label>Penalty</label>
//                         <input type="text" value={`${penalty} tk`} readOnly />
//                       </div>
//                       <div className="electricianorder-col">
//                         <label>Total Price</label>
//                         <input
//                           type="text"
//                           value={`${finalPrice} tk`}
//                           readOnly
//                         />
//                       </div>
//                     </>
//                   ) : (
//                     <div className="electricianorder-col">
//                       <label>Total Price</label>
//                       <input type="text" value={`${finalPrice} tk`} readOnly />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//             <div className="electricianorder-button-container">
//               <button
//                 type="submit"
//                 className="electricianorder-button"
//                 onClick={handleSubmit}
//               >
//                 Place Order
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {showSuccessPopup && (
//         <div className="success-popup">
//           <div className="success-popup-content">
//             <h2>Order successfully placed!</h2>
//             <p>Thank you</p>
//             <p>Stay with HelpNao</p>
//             <button onClick={closePopup}>Ok</button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ElectricianOrderForm;

// ***************** All okay all works fine **************** //

// import React, { useState, useEffect } from "react";
// import "./electricianOrderForm.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";

// const ElectricianOrderForm = ({ user, formData, onClose, serviceId }) => {
//   const [orderData, setOrderData] = useState({
//     city: user?.city || "",
//     address: user?.Address || "",
//     mobile: user?.mobile || "",
//   });
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showForm, setShowForm] = useState(true);

//   const [showBlockedPopup, setShowBlockedPopup] = useState(false);

//   const penalty = user && user.penalty ? Number(user.penalty) : 0;
//   const basePrice = Number(formData.price) || 0;
//   const finalPrice = user.penaltyReserved
//     ? basePrice
//     : basePrice + (user.penalty ? Number(user.penalty) : 0);

//   // useEffect(() => {
//   //   if (user) {
//   //     setOrderData({
//   //       city: user.city || "",
//   //       address: user.Address || "",
//   //       mobile: user.mobile || "",
//   //     });
//   //   }
//   // }, [user]);

//   useEffect(() => {
//       if (user) {
//         // Added: Check if user status is "Blocked"
//         if (user.status === "Blocked") {
//           setShowBlockedPopup(true);
//           setShowForm(false); // Prevent form from showing
//         } else {
//           setOrderData({
//             city: user.city || "",
//             address: user.Address || "",
//             mobile: user.mobile || "",
//           });
//         }
//       }
//     }, [user]);

//   // Disable background scroll when modal is open
//   useEffect(() => {
//     document.body.style.overflow = 'hidden';
//     return () => {
//       document.body.style.overflow = 'auto';
//     };
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setOrderData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const formatDate = (dateStr) => {
//     const dateObj = new Date(dateStr);
//     const day = dateObj.getDate();
//     const month = dateObj.toLocaleString('default', { month: 'short' });
//     const year = dateObj.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const finalOrderData = {
//       userId: user.Id,
//       usercity: orderData.city,
//       useraddress: orderData.address,
//       fanInstall: formData.fanInstall,
//       lightInstall: formData.lightInstall,
//       fanRepair: formData.fanRepair,
//       lightRepair: formData.lightRepair,
//       switchBoardRepair: formData.switchBoardRepair,
//       distributionBoardServicing: formData.distributionBoardServicing,
//       mcbServicing: formData.mcbServicing,
//       price: formData.price,
//       date: formData.date,
//       time: formData.time,
//       status: "pending",
//       servitor_id: 0,
//       serviceId: 1,
//     };

//     try {
//       const response = await axios.post(
//         "http://localhost:4001/electrician",
//         finalOrderData
//       );
//       console.log("Order placed successfully:", response.data);
//       setShowForm(false);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error placing order:", error);
//     }

//   };

//   const closePopup = () => {
//     setShowSuccessPopup(false);
//     onClose();
//   };

//   // Handler for closing the blocked popup
//   const closeBlockedPopup = () => {
//     setShowBlockedPopup(false);
//     onClose(); // Close the entire modal and go back
//   };

//   return (
//     <>
//       {showForm && (
//         <div className="electricianorder-modal">
//           <div className="electricianorder-overlay" onClick={onClose}></div>
//           <div className="electricianorder-form-container">
//             <div className="electricianorder-form-header">
//               <div className="header-content">
//                 <h2>Order Details</h2>
//               </div>
//               <button className="close-button" onClick={onClose}>
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>
//             <hr />
//             <div className="electricianorder-form-content">
//               <div className="electricianorder-left">
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Name</label>
//                     <input
//                       type="text"
//                       value={`${user.FirstName} ${user.LastName}`}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Mobile</label>
//                     <input
//                       type="text"
//                       value={"0" + orderData.mobile}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>City</label>
//                     <select
//                       id="city"
//                       name="city"
//                       value={orderData.city}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select your City</option>
//                       <option value="Dhaka">Dhaka</option>
//                       <option value="Chattogram">Chattogram</option>
//                       <option value="Barishal">Barishal</option>
//                       <option value="Sylhet">Sylhet</option>
//                       <option value="Rajshahi">Rajshahi</option>
//                       <option value="Khulna">Khulna</option>
//                       <option value="Rangpur">Rangpur</option>
//                       <option value="Maymensingh">Maymensingh</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Address</label>
//                     <input
//                       type="text"
//                       name="address"
//                       value={orderData.address}
//                       onChange={handleChange}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="electricianorder-right">
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Fan Install/Uninstall</label>
//                     <input type="text" value={formData.fanInstall} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Light Install/Uninstall</label>
//                     <input type="text" value={formData.lightInstall} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Fan Repair</label>
//                     <input type="text" value={formData.fanRepair} readOnly />
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Light Repair</label>
//                     <input type="text" value={formData.lightRepair} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Switch Board Repair</label>
//                     <input
//                       type="text"
//                       value={formData.switchBoardRepair}
//                       readOnly
//                     />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>MDB Servicing</label>
//                     <input
//                       type="text"
//                       value={formData.distributionBoardServicing}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>MCB Servicing</label>
//                     <input type="text" value={formData.mcbServicing} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Date</label>
//                     <input type="text" value={formatDate(formData.date)} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Time</label>
//                     <input type="text" value={formData.time} readOnly />
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   {!user.penaltyReserved && penalty > 0 ? (
//                     <>
//                       <div className="electricianorder-col">
//                         <label>Base Price</label>
//                         <input type="text" value={`${basePrice} tk`} readOnly />
//                       </div>
//                       <div className="electricianorder-col">
//                         <label>Penalty</label>
//                         <input type="text" value={`${penalty} tk`} readOnly />
//                       </div>
//                       <div className="electricianorder-col">
//                         <label>Total Price</label>
//                         <input
//                           type="text"
//                           value={`${finalPrice} tk`}
//                           readOnly
//                         />
//                       </div>
//                     </>
//                   ) : (
//                     <div className="electricianorder-col">
//                       <label>Total Price</label>
//                       <input type="text" value={`${finalPrice} tk`} readOnly />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//             <div className="electricianorder-button-container">
//               <button
//                 type="submit"
//                 className="electricianorder-button"
//                 onClick={handleSubmit}
//               >
//                 Place Order
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {showSuccessPopup && (
//         <div className="electricianorder-success-popup">
//           <div className="electricianorder-success-popup-content">
//             <h2>Order successfully placed!</h2>
//             <p>Thank you</p>
//             <p>Stay with HelpNao</p>
//             <button onClick={closePopup}>Ok</button>
//           </div>
//         </div>
//       )}

//       {showBlockedPopup && (
//         <div className="electricianorder-success-popup">
//           <div className="electricianorder-success-popup-content">
//             <h2>Account Blocked</h2>
//             <p>Your account is blocked due to excessive cancellations.</p>
//             <p>Please contact our support team for assistance.</p>
//             <button onClick={closeBlockedPopup}>Close</button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ElectricianOrderForm;

// **************** New update with new features and all is okay**************** //

// import React, { useState, useEffect } from "react";
// import "./electricianOrderForm.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";

// const ElectricianOrderForm = ({ user, formData, onClose, serviceId }) => {
//   const [orderData, setOrderData] = useState({
//     city: user?.city || "",
//     address: user?.Address || "",
//     mobile: user?.mobile || "",
//   });
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showForm, setShowForm] = useState(true);

//   const [showBlockedPopup, setShowBlockedPopup] = useState(false);

//   const penalty = user && user.penalty ? Number(user.penalty) : 0;
//   const basePrice = Number(formData.price) || 0;
//   const finalPrice = user.penaltyReserved
//     ? basePrice
//     : basePrice + (user.penalty ? Number(user.penalty) : 0);

//   // useEffect(() => {
//   //   if (user) {
//   //     setOrderData({
//   //       city: user.city || "",
//   //       address: user.Address || "",
//   //       mobile: user.mobile || "",
//   //     });
//   //   }
//   // }, [user]);

//   useEffect(() => {
//       if (user) {
//         // Added: Check if user status is "Blocked"
//         if (user.status === "Blocked") {
//           setShowBlockedPopup(true);
//           setShowForm(false); // Prevent form from showing
//         } else {
//           setOrderData({
//             city: user.city || "",
//             address: user.Address || "",
//             mobile: user.mobile || "",
//           });
//         }
//       }
//     }, [user]);

//   // Disable background scroll when modal is open
//   useEffect(() => {
//     document.body.style.overflow = 'hidden';
//     return () => {
//       document.body.style.overflow = 'auto';
//     };
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setOrderData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const formatDate = (dateStr) => {
//     const dateObj = new Date(dateStr);
//     const day = dateObj.getDate();
//     const month = dateObj.toLocaleString('default', { month: 'short' });
//     const year = dateObj.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const finalOrderData = {
//       userId: user.Id,
//       usercity: orderData.city,
//       useraddress: orderData.address,
//       fanInstall: formData.fanInstall,
//       lightInstall: formData.lightInstall,
//       fanRepair: formData.fanRepair,
//       lightRepair: formData.lightRepair,
//       switchBoardRepair: formData.switchBoardRepair,
//       distributionBoardServicing: formData.distributionBoardServicing,
//       mcbServicing: formData.mcbServicing,

//       // ← NEW: regulator
//       regulatorInstall:  formData.regulatorInstall,
//       regulatorRepair:   formData.regulatorRepair,

//       // ← NEW: sockets
//       socketInstall:     formData.socketInstall,
//       socketRepair:      formData.socketRepair,

//       // ← NEW: breakers & wiring
//       breakerRepair:     formData.breakerRepair,
//       newWiringPoint:    formData.newWiringPoint,
//       fullWiring:        formData.fullWiring,    // boolean
//       electricalCheckup: formData.checkupPoints, // up to 3

//       // price: formData.price,
//       price: finalPrice,
//       date: formData.date,
//       time: formData.time,
//       status: "pending",
//       servitor_id: 0,
//       serviceId: 1,
//     };

//     try {
//       const response = await axios.post(
//         "http://localhost:4001/electrician",
//         finalOrderData
//       );
//       console.log("Order placed successfully:", response.data);
//       setShowForm(false);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error placing order:", error);
//     }

//   };

//   const closePopup = () => {
//     setShowSuccessPopup(false);
//     onClose();
//   };

//   // Handler for closing the blocked popup
//   const closeBlockedPopup = () => {
//     setShowBlockedPopup(false);
//     onClose(); // Close the entire modal and go back
//   };

//   return (
//     <>
//       {showForm && (
//         <div className="electricianorder-modal">
//           <div className="electricianorder-overlay" onClick={onClose}></div>
//           <div className="electricianorder-form-container">
//             <div className="electricianorder-form-header">
//               <div className="header-content">
//                 <h2>Order Details</h2>
//               </div>
//               <button className="close-button" onClick={onClose}>
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>
//             <hr />
//             <div className="electricianorder-form-content">
//               <div className="electricianorder-left">
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Name</label>
//                     <input
//                       type="text"
//                       value={`${user.FirstName} ${user.LastName}`}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Mobile</label>
//                     <input
//                       type="text"
//                       value={"0" + orderData.mobile}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>City</label>
//                     <select
//                       id="city"
//                       name="city"
//                       value={orderData.city}
//                       onChange={handleChange}
//                     >
//                       <option value="">Select your City</option>
//                       <option value="Dhaka">Dhaka</option>
//                       <option value="Chattogram">Chattogram</option>
//                       <option value="Barishal">Barishal</option>
//                       <option value="Sylhet">Sylhet</option>
//                       <option value="Rajshahi">Rajshahi</option>
//                       <option value="Khulna">Khulna</option>
//                       <option value="Rangpur">Rangpur</option>
//                       <option value="Maymensingh">Maymensingh</option>
//                     </select>
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Address</label>
//                     <input
//                       type="text"
//                       name="address"
//                       value={orderData.address}
//                       onChange={handleChange}
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="electricianorder-right">
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Fan Install/Uninstall</label>
//                     <input type="text" value={formData.fanInstall} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Light Install/Uninstall</label>
//                     <input type="text" value={formData.lightInstall} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Fan Repair</label>
//                     <input type="text" value={formData.fanRepair} readOnly />
//                   </div>

//                 </div>

//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Regulator Install/Uninstall</label>
//                     <input type="text" value={formData.regulatorInstall} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Regulator Repair</label>
//                     <input type="text" value={formData.regulatorRepair} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Socket Install/Uninstall</label>
//                     <input type="text" value={formData.socketInstall} readOnly />
//                   </div>
//                 </div>

//                  <div className="electricianorder-row">
//                  <div className="electricianorder-col">
//                     <label>Socket Repair</label>
//                     <input type="text" value={formData.socketRepair} readOnly />
//                   </div>
//                    <div className="electricianorder-col">
//                     <label>Circuit Breaker Repair</label>
//                     <input type="text" value={formData.breakerRepair} readOnly />
//                   </div>
//                    <div className="electricianorder-col">
//                     <label>New Wiring Point</label>
//                     <input type="text" value={formData.newWiringPoint} readOnly />
//                   </div>
//                 </div>

//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Full Wiring</label>
//                     <input
//                       type="text"
//                       value={formData.fullWiring ? "Yes" : "No"}
//                       readOnly
//                     />
//                   </div>
//                    <div className="electricianorder-col">
//                     <label>Electrical Checkup</label>
//                     <input type="text" value={formData.checkupPoints} readOnly />
//                   </div>
//                 </div>

//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>Light Repair</label>
//                     <input type="text" value={formData.lightRepair} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Switch Board Repair</label>
//                     <input
//                       type="text"
//                       value={formData.switchBoardRepair}
//                       readOnly
//                     />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>MDB Servicing</label>
//                     <input
//                       type="text"
//                       value={formData.distributionBoardServicing}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   <div className="electricianorder-col">
//                     <label>MCB Servicing</label>
//                     <input type="text" value={formData.mcbServicing} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Date</label>
//                     <input type="text" value={formatDate(formData.date)} readOnly />
//                   </div>
//                   <div className="electricianorder-col">
//                     <label>Time</label>
//                     <input type="text" value={formData.time} readOnly />
//                   </div>
//                 </div>
//                 <div className="electricianorder-row">
//                   {!user.penaltyReserved && penalty > 0 ? (
//                     <>
//                       <div className="electricianorder-col">
//                         <label>Base Price</label>
//                         <input type="text" value={`${basePrice} tk`} readOnly />
//                       </div>
//                       <div className="electricianorder-col">
//                         <label>Penalty</label>
//                         <input type="text" value={`${penalty} tk`} readOnly />
//                       </div>
//                       <div className="electricianorder-col">
//                         <label>Total Price</label>
//                         <input
//                           type="text"
//                           value={`${finalPrice} tk`}
//                           readOnly
//                         />
//                       </div>
//                     </>
//                   ) : (
//                     <div className="electricianorder-col">
//                       <label>Total Price</label>
//                       <input type="text" value={`${finalPrice} tk`} readOnly />
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//             <div className="electricianorder-button-container">
//               <button
//                 type="submit"
//                 className="electricianorder-button"
//                 onClick={handleSubmit}
//               >
//                 Place Order
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//       {showSuccessPopup && (
//         <div className="electricianorder-success-popup">
//           <div className="electricianorder-success-popup-content">
//             <h2>Order successfully placed!</h2>
//             <p>Thank you</p>
//             <p>Stay with HelpNao</p>
//             <button onClick={closePopup}>Ok</button>
//           </div>
//         </div>
//       )}

//       {showBlockedPopup && (
//         <div className="electricianorder-success-popup">
//           <div className="electricianorder-success-popup-content">
//             <h2>Account Blocked</h2>
//             <p>Your account is blocked due to excessive cancellations.</p>
//             <p>Please contact our support team for assistance.</p>
//             <button onClick={closeBlockedPopup}>Close</button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ElectricianOrderForm;

// ***************** Update for new design All Okay and checked (19-6-25)********************** //
// import React, { useState, useEffect } from "react";
// import "./electricianOrderForm.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes, faUser, faCalendarAlt, faTools, faFan, faLightbulb, faServer, faPlug } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";

// const ElectricianOrderForm = ({ user, formData, onClose, serviceId }) => {
//   const [orderData, setOrderData] = useState({
//     city: user?.city || "",
//     address: user?.Address || "",
//     mobile: user?.mobile || "",
//   });
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showForm, setShowForm] = useState(true);
//   const [showBlockedPopup, setShowBlockedPopup] = useState(false);

//   const penalty = user && user.penalty ? Number(user.penalty) : 0;
//   const basePrice = Number(formData.price) || 0;
//   const finalPrice = user.penaltyReserved ? basePrice : basePrice + penalty;

//   useEffect(() => {
//     if (user) {
//       if (user.status === "Blocked") {
//         setShowBlockedPopup(true);
//         setShowForm(false);
//       } else {
//         setOrderData({
//           city: user.city || "",
//           address: user.Address || "",
//           mobile: user.mobile || "",
//         });
//       }
//     }
//   }, [user]);

//   // Disable background scroll when modal is open
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setOrderData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const formatDate = (dateStr) => {
//     const dateObj = new Date(dateStr);
//     const day = dateObj.getDate();
//     const month = dateObj.toLocaleString("default", { month: "short" });
//     const year = dateObj.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const finalOrderData = {
//       userId: user.Id,
//       usercity: orderData.city,
//       useraddress: orderData.address,
//       fanInstall: formData.fanInstall,
//       lightInstall: formData.lightInstall,
//       fanRepair: formData.fanRepair,
//       lightRepair: formData.lightRepair,
//       switchBoardRepair: formData.switchBoardRepair,
//       distributionBoardServicing: formData.distributionBoardServicing,
//       mcbServicing: formData.mcbServicing,
//       regulatorInstall: formData.regulatorInstall,
//       regulatorRepair: formData.regulatorRepair,
//       socketInstall: formData.socketInstall,
//       socketRepair: formData.socketRepair,
//       breakerRepair: formData.breakerRepair,
//       newWiringPoint: formData.newWiringPoint,
//       fullWiring: formData.fullWiring,
//       electricalCheckup: formData.needsCheckup,
//       price: formData.price,
//       // price: finalPrice,
//       date: formData.date,
//       time: formData.time,
//       status: "pending",
//       servitor_id: 0,
//       serviceId: 1,
//     };

//     try {
//       const response = await axios.post("http://localhost:4001/electrician", finalOrderData);
//       console.log("Order placed successfully:", response.data);
//       setShowForm(false);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error placing order:", error);
//     }
//   };

//   const closePopup = () => {
//     setShowSuccessPopup(false);
//     onClose();
//   };

//   const closeBlockedPopup = () => {
//     setShowBlockedPopup(false);
//     onClose();
//   };

//   return (
//     <>
//       {showForm && (
//         <div className="electricianorder-modal-backdrop">
//           <div className="electricianorder-modal-content">
//             <div className="electricianorder-modal-header">
//               <h2 className="electricianorder-modal-title">Order Details</h2>
//               <button
//                 className="electricianorder-modal-close"
//                 onClick={onClose}
//               >
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>

//             <div className="electricianorder-modal-body">
//               <div className="electricianorder-two-column-grid">
//                 {/* Customer Information Card */}
//                 <div className="electricianorder-modal-card">
//                   <div className="electricianorder-card-body">
//                     <h3 className="electricianorder-card-title">
//                       <FontAwesomeIcon icon={faUser} /> Customer Information
//                     </h3>
//                     <div className="electricianorder-form-grid">
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           Name
//                         </label>
//                         <input
//                           type="text"
//                           className="electricianorder-form-control"
//                           value={`${user.FirstName} ${user.LastName}`}
//                           readOnly
//                         />
//                       </div>
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           Mobile
//                         </label>
//                         <input
//                           type="text"
//                           className="electricianorder-form-control"
//                           value={`0${orderData.mobile}`}
//                           readOnly
//                         />
//                       </div>
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           City
//                         </label>
//                         <select
//                           name="city"
//                           className="electricianorder-form-control"
//                           value={orderData.city}
//                           onChange={handleChange}
//                         >
//                           <option value="">Select your City</option>
//                           <option value="Dhaka">Dhaka</option>
//                           <option value="Chattogram">Chattogram</option>
//                           <option value="Barishal">Barishal</option>
//                           <option value="Sylhet">Sylhet</option>
//                           <option value="Rajshahi">Rajshahi</option>
//                           <option value="Khulna">Khulna</option>
//                           <option value="Rangpur">Rangpur</option>
//                           <option value="Maymensingh">Maymensingh</option>
//                         </select>
//                       </div>
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           Address
//                         </label>
//                         <textarea
//                           name="address"
//                           className="electricianorder-form-control"
//                           rows="3"
//                           value={orderData.address}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Booking Details Card */}
//                 <div className="electricianorder-modal-card">
//                   <div className="electricianorder-card-body">
//                     <h3 className="electricianorder-card-title">
//                       <FontAwesomeIcon icon={faCalendarAlt} /> Booking Details
//                     </h3>
//                     <div className="electricianorder-form-grid">
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           Date
//                         </label>
//                         <input
//                           type="text"
//                           className="electricianorder-form-control"
//                           value={formatDate(formData.date)}
//                           readOnly
//                         />
//                       </div>
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           Time
//                         </label>
//                         <input
//                           type="text"
//                           className="electricianorder-form-control"
//                           value={formData.time}
//                           readOnly
//                         />
//                       </div>
//                       {!user.penaltyReserved && penalty > 0 ? (
//                         <>
//                           <div className="electricianorder-form-group">
//                             <label className="electricianorder-form-label">
//                               Base Price
//                             </label>
//                             <input
//                               type="text"
//                               className="electricianorder-form-control"
//                               value={`${basePrice} tk`}
//                               readOnly
//                             />
//                           </div>
//                           <div className="electricianorder-form-group">
//                             <label className="electricianorder-form-label">
//                               Penalty
//                             </label>
//                             <input
//                               type="text"
//                               className="electricianorder-form-control"
//                               value={`${penalty} tk`}
//                               readOnly
//                             />
//                           </div>
//                           <div className="electricianorder-form-group">
//                             <label className="electricianorder-form-label">
//                               Total Price
//                             </label>
//                             <input
//                               type="text"
//                               className="electricianorder-form-control electricianorder-total-price"
//                               value={`${finalPrice} tk`}
//                               readOnly
//                             />
//                           </div>
//                         </>
//                       ) : (
//                         <div className="electricianorder-form-group">
//                           <label className="electricianorder-form-label">
//                             Total Price
//                           </label>
//                           <input
//                             type="text"
//                             className="electricianorder-form-control electricianorder-total-price"
//                             value={`${finalPrice} tk`}
//                             readOnly
//                           />
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Service Details Card */}
//               <div className="electricianorder-modal-card">
//                 <div className="electricianorder-card-body">
//                   <h3 className="electricianorder-card-title">
//                     {/* <FontAwesomeIcon icon={faTools} /> Service Details */}
//                      Service Details
//                   </h3>
//                   <div className="electricianorder-services-section">
//                     {/* Fans & Regulators */}
//                     <div className="electricianorder-service-category">
//                       <h4 className="electricianorder-category-header">
//                         <FontAwesomeIcon icon={faFan} /> Fans & Regulators
//                       </h4>
//                       <div className="electricianorder-services-grid">
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             Fan Install/Uninstall
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.fanInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.fanInstall}{" "}
//                             <span className="electricianorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             Fan Repair
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.fanRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.fanRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             Regulator Install/Uninstall
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.regulatorInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.regulatorInstall}{" "}
//                             <span className="electricianorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             Regulator Repair
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.regulatorRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.regulatorRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Lights & Sockets */}
//                     <div className="electricianorder-service-category">
//                       <h4 className="electricianorder-category-header">
//                         <FontAwesomeIcon icon={faLightbulb} /> Lights & Sockets
//                       </h4>
//                       <div className="electricianorder-services-grid">
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             Light Install/Uninstall
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.lightInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.lightInstall}{" "}
//                             <span className="electricianorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             Light Repair
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.lightRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.lightRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             Socket Install/Uninstall
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.socketInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.socketInstall}{" "}
//                             <span className="electricianorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             Socket Repair
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.socketRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.socketRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Panels & Breakers */}
//                     <div className="electricianorder-service-category">
//                       <h4 className="electricianorder-category-header">
//                         <FontAwesomeIcon icon={faServer} /> Panels & Breakers
//                       </h4>
//                       <div className="electricianorder-services-grid">
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             Switch Board Repair
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.switchBoardRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.switchBoardRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             MCB Servicing
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.mcbServicing > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.mcbServicing}{" "}
//                             <span className="electricianorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             MDB Servicing
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.distributionBoardServicing > 0
//                                 ? "has-value"
//                                 : ""
//                             }`}
//                           >
//                             {formData.distributionBoardServicing}{" "}
//                             <span className="electricianorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             Circuit Breaker Repair
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.breakerRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.breakerRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     {/* Wiring & Checkup */}
//                     <div className="electricianorder-service-category">
//                       <h4 className="electricianorder-category-header">
//                         <FontAwesomeIcon icon={faPlug} /> Wiring & Checkup
//                       </h4>
//                       <div className="electricianorder-services-grid">
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             New Wiring Point
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.newWiringPoint > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.newWiringPoint}{" "}
//                             <span className="electricianorder-service-unit">
//                               units
//                             </span>
//                           </div>
//                         </div>
//                         {/* <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">Electrical Checkup</label>
//                           <div className={`electricianorder-service-value ${formData.checkupPoints > 0 ? "has-value" : ""}`}>
//                             {formData.checkupPoints} <span className="electricianorder-service-unit">units</span>
//                           </div>
//                         </div> */}
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             Electrical Checkup
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.needsCheckup ? "boolean-true" : ""
//                             }`}
//                           >
//                             {formData.needsCheckup ? "Yes" : "No"}
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             Full Wiring
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.fullWiring ? "boolean-true" : ""
//                             }`}
//                           >
//                             {formData.fullWiring ? "Yes" : "No"}
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="electricianorder-order-actions">
//               <button
//                 className="electricianorder-btn electricianorder-btn-outline"
//                 onClick={onClose}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="electricianorder-btn electricianorder-btn-primary"
//                 onClick={handleSubmit}
//               >
//                 <FontAwesomeIcon icon={faTools} /> Place Order
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {showSuccessPopup && (
//         <div className="electricianorder-success-popup">
//           <div className="electricianorder-success-popup-content">
//             <h2>Order Successfully Placed!</h2>
//             <p>Thank you for choosing HelpNao.</p>
//             <p>Your order is now pending confirmation.</p>
//             <button
//               className="electricianorder-btn electricianorder-btn-primary"
//               onClick={closePopup}
//             >
//               Ok
//             </button>
//           </div>
//         </div>
//       )}

//       {showBlockedPopup && (
//         <div className="electricianorder-success-popup">
//           <div className="electricianorder-success-popup-content">
//             <h2>Account Blocked</h2>
//             <p>Your account is blocked due to excessive cancellations.</p>
//             <p>Please contact our support team for assistance.</p>
//             <button
//               className="electricianorder-btn electricianorder-btn-primary"
//               onClick={closeBlockedPopup}
//             >
//               Close
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ElectricianOrderForm;

// ***** Upper code All checked All okay (19-6-25) ***** //

// ***** New added Translate EN-BN (19-6-25) ***** //

// import React, { useState, useEffect } from "react";
// import "./electricianOrderForm.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faTimes, faUser, faCalendarAlt, faTools, faFan, faLightbulb, faServer, faPlug } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
// import { useTranslation } from 'react-i18next';

// const ElectricianOrderForm = ({ user, formData, onClose, serviceId }) => {
//   const { t } = useTranslation();

//   const [orderData, setOrderData] = useState({
//     city: user?.city || "",
//     address: user?.Address || "",
//     mobile: user?.mobile || "",
//   });
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showForm, setShowForm] = useState(true);
//   const [showBlockedPopup, setShowBlockedPopup] = useState(false);

//   const penalty = user && user.penalty ? Number(user.penalty) : 0;
//   const basePrice = Number(formData.price) || 0;
//   const finalPrice = user.penaltyReserved ? basePrice : basePrice + penalty;

//   useEffect(() => {
//     if (user) {
//       if (user.status === "Blocked") {
//         setShowBlockedPopup(true);
//         setShowForm(false);
//       } else {
//         setOrderData({
//           city: user.city || "",
//           address: user.Address || "",
//           mobile: user.mobile || "",
//         });
//       }
//     }
//   }, [user]);

//   // Disable background scroll when modal is open
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setOrderData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const formatDate = (dateStr) => {
//     const dateObj = new Date(dateStr);
//     const day = dateObj.getDate();
//     const month = dateObj.toLocaleString("default", { month: "short" });
//     const year = dateObj.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const finalOrderData = {
//       userId: user.Id,
//       usercity: orderData.city,
//       useraddress: orderData.address,
//       fanInstall: formData.fanInstall,
//       lightInstall: formData.lightInstall,
//       fanRepair: formData.fanRepair,
//       lightRepair: formData.lightRepair,
//       switchBoardRepair: formData.switchBoardRepair,
//       distributionBoardServicing: formData.distributionBoardServicing,
//       mcbServicing: formData.mcbServicing,
//       regulatorInstall: formData.regulatorInstall,
//       regulatorRepair: formData.regulatorRepair,
//       socketInstall: formData.socketInstall,
//       socketRepair: formData.socketRepair,
//       breakerRepair: formData.breakerRepair,
//       newWiringPoint: formData.newWiringPoint,
//       fullWiring: formData.fullWiring,
//       electricalCheckup: formData.needsCheckup,
//       price: formData.price,
//       // price: finalPrice,
//       date: formData.date,
//       time: formData.time,
//       status: "pending",
//       servitor_id: 0,
//       serviceId: 1,
//     };

//     try {
//       const response = await axios.post("http://localhost:4001/electrician", finalOrderData);
//       console.log("Order placed successfully:", response.data);
//       setShowForm(false);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error placing order:", error);
//     }
//   };

//   const closePopup = () => {
//     setShowSuccessPopup(false);
//     onClose();
//   };

//   const closeBlockedPopup = () => {
//     setShowBlockedPopup(false);
//     onClose();
//   };

//  return (
//      <>
//        {showForm && (
//          <div className="electricianorder-modal-backdrop">
//            <div className="electricianorder-modal-content">
//              <div className="electricianorder-modal-header">
//                <h2 className="electricianorder-modal-title">
//                  {/* Order Details */}
//                  {t('electricianorderform.order_form.modal.title')} {/* CHANGED: Updated to new namespace */}
//                </h2>
//                <button
//                  className="electricianorder-modal-close"
//                  onClick={onClose}
//                  aria-label={t('electricianorderform.order_form.modal.close_button')}
//                >
//                  <FontAwesomeIcon icon={faTimes} />
//                </button>
//              </div>

//              <div className="electricianorder-modal-body">
//                <div className="electricianorder-two-column-grid">
//                  <div className="electricianorder-modal-card">
//                    <div className="electricianorder-card-body">
//                      <h3 className="electricianorder-card-title">
//                        <FontAwesomeIcon icon={faUser} />
//                        {/* Customer Information */}
//                        {t('electricianorderform.order_form.customer_information.title')} {/* CHANGED: Updated to new namespace */}
//                      </h3>
//                      <div className="electricianorder-form-grid">
//                        <div className="electricianorder-form-group">
//                          <label className="electricianorder-form-label">
//                            {/* Name */}
//                            {t('electricianorderform.order_form.customer_information.labels.name')} {/* CHANGED: Updated to new namespace */}
//                          </label>
//                          <input
//                            type="text"
//                            className="electricianorder-form-control"
//                            value={`${user.FirstName} ${user.LastName}`}
//                            readOnly
//                          />
//                        </div>
//                        <div className="electricianorder-form-group">
//                          <label className="electricianorder-form-label">
//                            {/* Mobile */}
//                            {t('electricianorderform.order_form.customer_information.labels.mobile')} {/* CHANGED: Updated to new namespace */}
//                          </label>
//                          <input
//                            type="text"
//                            className="electricianorder-form-control"
//                            value={`0${orderData.mobile}`}
//                            readOnly
//                          />
//                        </div>
//                        <div className="electricianorder-form-group">
//                          <label className="electricianorder-form-label">
//                            {/* City */}
//                            {t('electricianorderform.order_form.customer_information.labels.city')} {/* CHANGED: Updated to new namespace */}
//                          </label>
//                          <select
//                            name="city"
//                            className="electricianorder-form-control"
//                            value={orderData.city}
//                            onChange={handleChange}
//                          >
//                            <option value="">
//                              {/* Select your City */}
//                              {t('electricianorderform.order_form.customer_information.labels.city_placeholder')} {/* CHANGED: Updated to new namespace */}
//                            </option>
//                            {/* {Object.entries(t('electricianorderform.order_form.customer_information.city_options', { returnObjects: true })).map(([key, value]) => (
//                              <option key={key} value={value}>{value}</option>
//                            ))} */}
//                            <option value="">
//                               {/* Select your City */}
//                               {t('plumberorderform.order_form.customer_information.labels.city_placeholder')} {/* CHANGED: Added translation */}
//                             </option>
//                             <option value="Dhaka">{t('homecleanorderform.order_form.customer_information.city_options.dhaka')}</option> {/* CHANGED: Reused translation */}
//                             <option value="Chattogram">{t('homecleanorderform.order_form.customer_information.city_options.chattogram')}</option> {/* CHANGED: Reused translation */}
//                             <option value="Barishal">{t('homecleanorderform.order_form.customer_information.city_options.barishal')}</option> {/* CHANGED: Reused translation */}
//                             <option value="Sylhet">{t('homecleanorderform.order_form.customer_information.city_options.sylhet')}</option> {/* CHANGED: Reused translation */}
//                             <option value="Rajshahi">{t('homecleanorderform.order_form.customer_information.city_options.rajshahi')}</option> {/* CHANGED: Reused translation */}
//                             <option value="Khulna">{t('homecleanorderform.order_form.customer_information.city_options.khulna')}</option> {/* CHANGED: Reused translation */}
//                             <option value="Rangpur">{t('homecleanorderform.order_form.customer_information.city_options.rangpur')}</option> {/* CHANGED: Reused translation */}
//                             <option value="Maymensingh">{t('homecleanorderform.order_form.customer_information.city_options.maymensingh')}</option> {/* CHANGED: Reused translation */}
//                          </select>
//                        </div>
//                        <div className="electricianorder-form-group">
//                          <label className="electricianorder-form-label">
//                            {/* Address */}
//                            {t('electricianorderform.order_form.customer_information.labels.address')} {/* CHANGED: Updated to new namespace */}
//                          </label>
//                          <textarea
//                            name="address"
//                            className="electricianorder-form-control"
//                            rows="3"
//                            value={orderData.address}
//                            onChange={handleChange}
//                          />
//                        </div>
//                      </div>
//                    </div>
//                  </div>

//                  <div className="electricianorder-modal-card">
//                    <div className="electricianorder-card-body">
//                      <h3 className="electricianorder-card-title">
//                        <FontAwesomeIcon icon={faCalendarAlt} />
//                        {/* Booking Details */}
//                        {t('electricianorderform.order_form.booking_details.title')} {/* CHANGED: Updated to new namespace */}
//                      </h3>
//                      <div className="electricianorder-form-grid">
//                        <div className="electricianorder-form-group">
//                          <label className="electricianorder-form-label">
//                            {/* Date */}
//                            {t('electricianorderform.order_form.booking_details.labels.date')} {/* CHANGED: Updated to new namespace */}
//                          </label>
//                          <input
//                            type="text"
//                            className="electricianorder-form-control"
//                            value={formatDate(formData.date)}
//                            readOnly
//                          />
//                        </div>
//                        <div className="electricianorder-form-group">
//                          <label className="electricianorder-form-label">
//                            {/* Time */}
//                            {t('electricianorderform.order_form.booking_details.labels.time')} {/* CHANGED: Updated to new namespace */}
//                          </label>
//                          <input
//                            type="text"
//                            className="electricianorder-form-control"
//                            value={formData.time}
//                            readOnly
//                          />
//                        </div>
//                        {!user.penaltyReserved && penalty > 0 ? (
//                          <>
//                            <div className="electricianorder-form-group">
//                              <label className="electricianorder-form-label">
//                                {/* Base Price */}
//                                {t('electricianorderform.order_form.booking_details.labels.base_price')} {/* CHANGED: Updated to new namespace */}
//                              </label>
//                              <input
//                                type="text"
//                                className="electricianorder-form-control"
//                                value={`${basePrice} tk`}
//                                readOnly
//                              />
//                            </div>
//                            <div className="electricianorder-form-group">
//                              <label className="electricianorder-form-label">
//                                {/* Penalty */}
//                                {t('electricianorderform.order_form.booking_details.labels.penalty')} {/* CHANGED: Updated to new namespace */}
//                              </label>
//                              <input
//                                type="text"
//                                className="electricianorder-form-control"
//                                value={`${penalty} tk`}
//                                readOnly
//                              />
//                            </div>
//                            <div className="electricianorder-form-group">
//                              <label className="electricianorder-form-label">
//                                {/* Total Price */}
//                                {t('electricianorderform.order_form.booking_details.labels.total_price')} {/* CHANGED: Updated to new namespace */}
//                              </label>
//                              <input
//                                type="text"
//                                className="electricianorder-form-control electricianorder-total-price"
//                                value={`${finalPrice} tk`}
//                                readOnly
//                              />
//                            </div>
//                          </>
//                        ) : (
//                          <div className="electricianorder-form-group">
//                            <label className="electricianorder-form-label">
//                              {/* Total Price */}
//                              {t('electricianorderform.order_form.booking_details.labels.total_price')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <input
//                              type="text"
//                              className="electricianorder-form-control electricianorder-total-price"
//                              value={`${finalPrice} tk`}
//                              readOnly
//                            />
//                          </div>
//                        )}
//                      </div>
//                    </div>
//                  </div>
//                </div>

//                <div className="electricianorder-modal-card">
//                  <div className="electricianorder-card-body">
//                    <h3 className="electricianorder-card-title">
//                      {/* Service Details */}
//                      {t('electricianorderform.order_form.service_details.title')} {/* CHANGED: Updated to new namespace */}
//                    </h3>
//                    <div className="electricianorder-services-section">
//                      <div className="electricianorder-service-category">
//                        <h4 className="electricianorder-category-header">
//                          <FontAwesomeIcon icon={faFan} />
//                          {/* Fans & Regulators */}
//                          {t('electricianorderform.order_form.service_details.categories.fans_regulators.title')} {/* CHANGED: Updated to new namespace */}
//                        </h4>
//                        <div className="electricianorder-services-grid">
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* Fan Install/Uninstall */}
//                              {t('electricianorderform.order_form.service_details.categories.fans_regulators.labels.fan_install')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                              className={`electricianorder-service-value ${formData.fanInstall > 0 ? "has-value" : ""}`}
//                            >
//                              {formData.fanInstall}{" "}
//                              <span className="electricianorder-service-unit">
//                                {/* units */}
//                                {t(formData.fanInstall === 1 ? 'electricianorderform.order_form.service_details.unit' : 'electricianorderform.order_form.service_details.units')} {/* CHANGED: Updated to new namespace */}
//                              </span>
//                            </div>
//                          </div>
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* Fan Repair */}
//                              {t('electricianorderform.order_form.service_details.categories.fans_regulators.labels.fan_repair')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                              className={`electricianorder-service-value ${formData.fanRepair > 0 ? "has-value" : ""}`}
//                            >
//                              {formData.fanRepair}{" "}
//                              <span className="electricianorder-service-unit">
//                                {/* units */}
//                                {t(formData.fanRepair === 1 ? 'electricianorderform.order_form.service_details.unit' : 'electricianorderform.order_form.service_details.units')} {/* CHANGED: Updated to new namespace */}
//                              </span>
//                            </div>
//                          </div>
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* Regulator Install/Uninstall */}
//                              {t('electricianorderform.order_form.service_details.categories.fans_regulators.labels.regulator_install')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                              className={`electricianorder-service-value ${formData.regulatorInstall > 0 ? "has-value" : ""}`}
//                            >
//                              {formData.regulatorInstall}{" "}
//                              <span className="electricianorder-service-unit">
//                                {/* units */}
//                                {t(formData.regulatorInstall === 1 ? 'electricianorderform.order_form.service_details.unit' : 'electricianorderform.order_form.service_details.units')} {/* CHANGED: Updated to new namespace */}
//                              </span>
//                            </div>
//                          </div>
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* Regulator Repair */}
//                              {t('electricianorderform.order_form.service_details.categories.fans_regulators.labels.regulator_repair')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                              className={`electricianorder-service-value ${formData.regulatorRepair > 0 ? "has-value" : ""}`}
//                            >
//                              {formData.regulatorRepair}{" "}
//                              <span className="electricianorder-service-unit">
//                                {/* units */}
//                                {t(formData.regulatorRepair === 1 ? 'electricianorderform.order_form.service_details.unit' : 'electricianorderform.order_form.service_details.units')} {/* CHANGED: Updated to new namespace */}
//                              </span>
//                            </div>
//                          </div>
//                        </div>
//                      </div>

//                      <div className="electricianorder-service-category">
//                        <h4 className="electricianorder-category-header">
//                          <FontAwesomeIcon icon={faLightbulb} />
//                          {/* Lights & Sockets */}
//                          {t('electricianorderform.order_form.service_details.categories.lights_sockets.title')} {/* CHANGED: Updated to new namespace */}
//                        </h4>
//                        <div className="electricianorder-services-grid">
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* Light Install/Uninstall */}
//                              {t('electricianorderform.order_form.service_details.categories.lights_sockets.labels.light_install')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                              className={`electricianorder-service-value ${formData.lightInstall > 0 ? "has-value" : ""}`}
//                            >
//                              {formData.lightInstall}{" "}
//                              <span className="electricianorder-service-unit">
//                                {/* units */}
//                                {t(formData.lightInstall === 1 ? 'electricianorderform.order_form.service_details.unit' : 'electricianorderform.order_form.service_details.units')} {/* CHANGED: Updated to new namespace */}
//                              </span>
//                            </div>
//                          </div>
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* Light Repair */}
//                              {t('electricianorderform.order_form.service_details.categories.lights_sockets.labels.light_repair')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                              className={`electricianorder-service-value ${formData.lightRepair > 0 ? "has-value" : ""}`}
//                            >
//                              {formData.lightRepair}{" "}
//                              <span className="electricianorder-service-unit">
//                                {/* units */}
//                                {t(formData.lightRepair === 1 ? 'electricianorderform.order_form.service_details.unit' : 'electricianorderform.order_form.service_details.units')} {/* CHANGED: Updated to new namespace */}
//                              </span>
//                            </div>
//                          </div>
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* Socket Install/Uninstall */}
//                              {t('electricianorderform.order_form.service_details.categories.lights_sockets.labels.socket_install')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                             gat
//                              className={`electricianorder-service-value ${formData.socketInstall > 0 ? "has-value" : ""}`}
//                            >
//                              {formData.socketInstall}{" "}
//                              <span className="electricianorder-service-unit">
//                                {/* units */}
//                                {t(formData.socketInstall === 1 ? 'electricianorderform.order_form.service_details.unit' : 'electricianorderform.order_form.service_details.units')} {/* CHANGED: Updated to new namespace */}
//                              </span>
//                            </div>
//                          </div>
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* Socket Repair */}
//                              {t('electricianorderform.order_form.service_details.categories.lights_sockets.labels.socket_repair')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                              className={`electricianorder-service-value ${formData.socketRepair > 0 ? "has-value" : ""}`}
//                            >
//                              {formData.socketRepair}{" "}
//                              <span className="electricianorder-service-unit">
//                                {/* units */}
//                                {t(formData.socketRepair === 1 ? 'electricianorderform.order_form.service_details.unit' : 'electricianorderform.order_form.service_details.units')} {/* CHANGED: Updated to new namespace */}
//                              </span>
//                            </div>
//                          </div>
//                        </div>
//                      </div>

//                      <div className="electricianorder-service-category">
//                        <h4 className="electricianorder-category-header">
//                          <FontAwesomeIcon icon={faServer} />
//                          {/* Panels & Breakers */}
//                          {t('electricianorderform.order_form.service_details.categories.panels_breakers.title')} {/* CHANGED: Updated to new namespace */}
//                        </h4>
//                        <div className="electricianorder-services-grid">
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* Switch Board Repair */}
//                              {t('electricianorderform.order_form.service_details.categories.panels_breakers.labels.switch_board_repair')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                              className={`electricianorder-service-value ${formData.switchBoardRepair > 0 ? "has-value" : ""}`}
//                            >
//                              {formData.switchBoardRepair}{" "}
//                              <span className="electricianorder-service-unit">
//                                {/* units */}
//                                {t(formData.switchBoardRepair === 1 ? 'electricianorderform.order_form.service_details.unit' : 'electricianorderform.order_form.service_details.units')} {/* CHANGED: Updated to new namespace */}
//                              </span>
//                            </div>
//                          </div>
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* MCB Servicing */}
//                              {t('electricianorderform.order_form.service_details.categories.panels_breakers.labels.mcb_servicing')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                              className={`electricianorder-service-value ${formData.mcbServicing > 0 ? "has-value" : ""}`}
//                            >
//                              {formData.mcbServicing}{" "}
//                              <span className="electricianorder-service-unit">
//                                {/* units */}
//                                {t(formData.mcbServicing === 1 ? 'electricianorderform.order_form.service_details.unit' : 'electricianorderform.order_form.service_details.units')} {/* CHANGED: Updated to new namespace */}
//                              </span>
//                            </div>
//                          </div>
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* MDB Servicing */}
//                              {t('electricianorderform.order_form.service_details.categories.panels_breakers.labels.mdb_servicing')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                              className={`electricianorder-service-value ${formData.distributionBoardServicing > 0 ? "has-value" : ""}`}
//                            >
//                              {formData.distributionBoardServicing}{" "}
//                              <span className="electricianorder-service-unit">
//                                {/* units */}
//                                {t(formData.distributionBoardServicing === 1 ? 'electricianorderform.order_form.service_details.unit' : 'electricianorderform.order_form.service_details.units')} {/* CHANGED: Updated to new namespace */}
//                              </span>
//                            </div>
//                          </div>
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* Circuit Breaker Repair */}
//                              {t('electricianorderform.order_form.service_details.categories.panels_breakers.labels.breaker_repair')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                              className={`electricianorder-service-value ${formData.breakerRepair > 0 ? "has-value" : ""}`}
//                            >
//                              {formData.breakerRepair}{" "}
//                              <span className="electricianorder-service-unit">
//                                {/* units */}
//                                {t(formData.breakerRepair === 1 ? 'electricianorderform.order_form.service_details.unit' : 'electricianorderform.order_form.service_details.units')} {/* CHANGED: Updated to new namespace */}
//                              </span>
//                            </div>
//                          </div>
//                        </div>
//                      </div>

//                      <div className="electricianorder-service-category">
//                        <h4 className="electricianorder-category-header">
//                          <FontAwesomeIcon icon={faPlug} />
//                          {/* Wiring & Checkup */}
//                          {t('electricianorderform.order_form.service_details.categories.wiring_checkup.title')} {/* CHANGED: Updated to new namespace */}
//                        </h4>
//                        <div className="electricianorder-services-grid">
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* New Wiring Point */}
//                              {t('electricianorderform.order_form.service_details.categories.wiring_checkup.labels.new_wiring_point')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                              className={`electricianorder-service-value ${formData.newWiringPoint > 0 ? "has-value" : ""}`}
//                            >
//                              {formData.newWiringPoint}{" "}
//                              <span className="electricianorder-service-unit">
//                                {/* units */}
//                                {t(formData.newWiringPoint === 1 ? 'electricianorderform.order_form.service_details.unit' : 'electricianorderform.order_form.service_details.units')} {/* CHANGED: Updated to new namespace */}
//                              </span>
//                            </div>
//                          </div>
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* Electrical Checkup */}
//                              {t('electricianorderform.order_form.service_details.categories.wiring_checkup.labels.electrical_checkup')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                              className={`electricianorder-service-value ${formData.needsCheckup ? "boolean-true" : ""}`}
//                            >
//                              {/* {formData.needsCheckup ? "Yes" : "No"} */}
//                              {t(`electricianorderform.order_form.service_details.categories.wiring_checkup.boolean.${formData.needsCheckup ? 'yes' : 'no'}`)} {/* CHANGED: Updated to new namespace */}
//                            </div>
//                          </div>
//                          <div className="electricianorder-service-item">
//                            <label className="electricianorder-form-label">
//                              {/* Full Wiring */}
//                              {t('electricianorderform.order_form.service_details.categories.wiring_checkup.labels.full_wiring')} {/* CHANGED: Updated to new namespace */}
//                            </label>
//                            <div
//                              className={`electricianorder-service-value ${formData.fullWiring ? "boolean-true" : ""}`}
//                            >
//                              {/* {formData.fullWiring ? "Yes" : "No"} */}
//                              {t(`electricianorderform.order_form.service_details.categories.wiring_checkup.boolean.${formData.fullWiring ? 'yes' : 'no'}`)} {/* CHANGED: Updated to new namespace */}
//                            </div>
//                          </div>
//                        </div>
//                      </div>
//                    </div>
//                  </div>
//                </div>
//              </div>

//              <div className="electricianorder-order-actions">
//                <button
//                  className="electricianorder-btn electricianorder-btn-outline"
//                  onClick={onClose}
//                >
//                  {/* Cancel */}
//                  {t('electricianorderform.order_form.actions.cancel')} {/* CHANGED: Updated to new namespace */}
//                </button>
//                <button
//                  className="electricianorder-btn electricianorder-btn-primary"
//                  onClick={handleSubmit}
//                >
//                  <FontAwesomeIcon icon={faTools} />
//                  {/* Place Order */}
//                  {t('electricianorderform.order_form.actions.place_order')} {/* CHANGED: Updated to new namespace */}
//                </button>
//              </div>
//            </div>
//          </div>
//        )}

//        {showSuccessPopup && (
//          <div className="electricianorder-success-popup">
//            <div className="electricianorder-success-popup-content">
//              <h2>
//                {/* Order Successfully Placed! */}
//                {t('electricianorderform.order_form.success_popup.title')} {/* CHANGED: Updated to new namespace */}
//              </h2>
//              <p>
//                {/* Thank you for choosing HelpNao. */}
//                {t('electricianorderform.order_form.success_popup.message1')} {/* CHANGED: Updated to new namespace */}
//              </p>
//              <p>
//                {/* Your order is now pending confirmation. */}
//                {t('electricianorderform.order_form.success_popup.message2')} {/* CHANGED: Updated to new namespace */}
//              </p>
//              <button
//                className="electricianorder-btn electricianorder-btn-primary"
//                onClick={closePopup}
//              >
//                {/* Ok */}
//                {t('electricianorderform.order_form.success_popup.button')} {/* CHANGED: Updated to new namespace */}
//              </button>
//            </div>
//          </div>
//        )}

//        {showBlockedPopup && (
//          <div className="electricianorder-success-popup">
//            <div className="electricianorder-success-popup-content">
//              <h2>
//                {/* Account Blocked */}
//                {t('electricianorderform.order_form.blocked_popup.title')} {/* CHANGED: Updated to new namespace */}
//              </h2>
//              <p>
//                {/* Your account is blocked due to excessive cancellations. */}
//                {t('electricianorderform.order_form.blocked_popup.message1')} {/* CHANGED: Updated to new namespace */}
//              </p>
//              <p>
//                {/* Please contact our support team for assistance. */}
//                {t('electricianorderform.order_form.blocked_popup.message2')} {/* CHANGED: Updated to new namespace */}
//              </p>
//              <button
//                className="electricianorder-btn electricianorder-btn-primary"
//                onClick={closeBlockedPopup}
//              >
//                {/* Close */}
//                {t('electricianorderform.order_form.blocked_popup.button')} {/* CHANGED: Updated to new namespace */}
//              </button>
//            </div>
//          </div>
//        )}
//      </>
//    );
//  };

// export default ElectricianOrderForm;

// ***** Update with Can Rebook same Servitor (29-6-25) ***** //

// import React, { useState, useEffect } from "react";
// import "./electricianOrderForm.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faTimes,
//   faUser,
//   faCalendarAlt,
//   faTools,
//   faFan,
//   faLightbulb,
//   faServer,
//   faPlug,
//   faCommentAlt,
//   faCheckCircle,
//   faWrench,
// } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
// import { useTranslation } from "react-i18next";

// const ElectricianOrderForm = ({
//   user,
//   formData,
//   onClose,
//   onSubmit,
//   previousServitorName,
//   serviceId,
// }) => {
//   const { t } = useTranslation();

//   const [orderData, setOrderData] = useState({
//     city: user?.city || "",
//     address: user?.Address || "",
//     mobile: user?.mobile || "",
//   });
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showForm, setShowForm] = useState(true);
//   const [showBlockedPopup, setShowBlockedPopup] = useState(false);

//   const penalty = user && user.penalty ? Number(user.penalty) : 0;
//   const basePrice = Number(formData.price) || 0;
//   const finalPrice = user.penaltyReserved ? basePrice : basePrice + penalty;

//   useEffect(() => {
//     if (user) {
//       if (user.status === "Blocked") {
//         setShowBlockedPopup(true);
//         setShowForm(false);
//       } else {
//         setOrderData({
//           city: user.city || "",
//           address: user.Address || "",
//           mobile: user.mobile || "",
//         });
//       }
//     }
//   }, [user]);

//   // Disable background scroll when modal is open
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setOrderData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const formatDate = (dateStr) => {
//     const dateObj = new Date(dateStr);
//     const day = dateObj.getDate();
//     const month = dateObj.toLocaleString("default", { month: "short" });
//     const year = dateObj.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const finalOrderData = {
//       userId: user.Id,
//       usercity: orderData.city,
//       useraddress: orderData.address,
//       fanInstall: formData.fanInstall,
//       lightInstall: formData.lightInstall,
//       fanRepair: formData.fanRepair,
//       lightRepair: formData.lightRepair,

//       doorbellSetup: formData.doorbellSetup,
//       exhaustFanSetup: formData.exhaustFanSetup,
//       exhaustFanRepair: formData.exhaustFanRepair,
//       drillWallHoles: formData.drillWallHoles,

//       switchBoardRepair: formData.switchBoardRepair,
//       distributionBoardServicing: formData.distributionBoardServicing,
//       mcbServicing: formData.mcbServicing,
//       regulatorInstall: formData.regulatorInstall,
//       regulatorRepair: formData.regulatorRepair,
//       socketInstall: formData.socketInstall,
//       socketRepair: formData.socketRepair,
//       breakerRepair: formData.breakerRepair,
//       newWiringPoint: formData.newWiringPoint,
//       fullWiring: formData.fullWiring,
//       electricalCheckup: formData.needsCheckup,
//       price: formData.price,

//       remarks: formData.remarks,
//       // price: finalPrice,
//       date: formData.date,
//       time: formData.time,
//       status: "pending",

//       // New added for Rebook same servitor
//       // servitor_id: 0,
//       servitor_id: formData.useSameServitor
//         ? formData.servitor_id // carried through from parent
//         : 0,

//       serviceId: 1,

//       // New added for Rebook same servitor
//       useSameServitor: formData.useSameServitor,
//       previousServitorId: formData.servitor_id,
//     };

//     try {
//       const response = await axios.post(
//         "http://localhost:4001/electrician",
//         finalOrderData
//       );
//       console.log("Order placed successfully:", response.data);
//       setShowForm(false);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error placing order:", error);
//     }
//   };

//   const closePopup = () => {
//     setShowSuccessPopup(false);
//     onClose();
//     onSubmit();
//   };

//   const closeBlockedPopup = () => {
//     setShowBlockedPopup(false);
//     onClose();
//   };

//   return (
//     <>
//       {showForm && (
//         <div className="electricianorder-modal-backdrop">
//           <div className="electricianorder-modal-content">
//             <div className="electricianorder-modal-header">
//               <h2 className="electricianorder-modal-title">
//                 {/* Order Details */}
//                 {t("electricianorderform.order_form.modal.title")}{" "}
//                 {/* CHANGED: Updated to new namespace */}
//               </h2>
//               <button
//                 className="electricianorder-modal-close"
//                 onClick={onClose}
//                 aria-label={t(
//                   "electricianorderform.order_form.modal.close_button"
//                 )}
//               >
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>

//             <div className="electricianorder-modal-body">
//               <div className="electricianorder-two-column-grid">
//                 <div className="electricianorder-modal-card">
//                   <div className="electricianorder-card-body">
//                     <h3 className="electricianorder-card-title">
//                       <FontAwesomeIcon icon={faUser} />
//                       {/* Customer Information */}
//                       {t(
//                         "electricianorderform.order_form.customer_information.title"
//                       )}{" "}
//                       {/* CHANGED: Updated to new namespace */}
//                     </h3>
//                     <div className="electricianorder-form-grid">
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {/* Name */}
//                           {t(
//                             "electricianorderform.order_form.customer_information.labels.name"
//                           )}{" "}
//                           {/* CHANGED: Updated to new namespace */}
//                         </label>
//                         <input
//                           type="text"
//                           className="electricianorder-form-control"
//                           value={`${user.FirstName} ${user.LastName}`}
//                           readOnly
//                         />
//                       </div>
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {/* Mobile */}
//                           {t(
//                             "electricianorderform.order_form.customer_information.labels.mobile"
//                           )}{" "}
//                           {/* CHANGED: Updated to new namespace */}
//                         </label>
//                         <input
//                           type="text"
//                           className="electricianorder-form-control"
//                           value={`0${orderData.mobile}`}
//                           readOnly
//                         />
//                       </div>
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {/* City */}
//                           {t(
//                             "electricianorderform.order_form.customer_information.labels.city"
//                           )}{" "}
//                           {/* CHANGED: Updated to new namespace */}
//                         </label>
//                         <select
//                           name="city"
//                           className="electricianorder-form-control"
//                           value={orderData.city}
//                           onChange={handleChange}
//                         >
//                           {/* <option value="">
//                              {t('electricianorderform.order_form.customer_information.labels.city_placeholder')}
//                            </option> */}
//                           {/* {Object.entries(t('electricianorderform.order_form.customer_information.city_options', { returnObjects: true })).map(([key, value]) => (
//                              <option key={key} value={value}>{value}</option>
//                            ))} */}
//                           <option value="">
//                             {/* Select your City */}
//                             {t(
//                               "plumberorderform.order_form.customer_information.labels.city_placeholder"
//                             )}{" "}
//                             {/* CHANGED: Added translation */}
//                           </option>
//                           <option value="Dhaka">
//                             {t(
//                               "homecleanorderform.order_form.customer_information.city_options.dhaka"
//                             )}
//                           </option>{" "}
//                           {/* CHANGED: Reused translation */}
//                           <option value="Chattogram">
//                             {t(
//                               "homecleanorderform.order_form.customer_information.city_options.chattogram"
//                             )}
//                           </option>{" "}
//                           {/* CHANGED: Reused translation */}
//                           <option value="Barishal">
//                             {t(
//                               "homecleanorderform.order_form.customer_information.city_options.barishal"
//                             )}
//                           </option>{" "}
//                           {/* CHANGED: Reused translation */}
//                           <option value="Sylhet">
//                             {t(
//                               "homecleanorderform.order_form.customer_information.city_options.sylhet"
//                             )}
//                           </option>{" "}
//                           {/* CHANGED: Reused translation */}
//                           <option value="Rajshahi">
//                             {t(
//                               "homecleanorderform.order_form.customer_information.city_options.rajshahi"
//                             )}
//                           </option>{" "}
//                           {/* CHANGED: Reused translation */}
//                           <option value="Khulna">
//                             {t(
//                               "homecleanorderform.order_form.customer_information.city_options.khulna"
//                             )}
//                           </option>{" "}
//                           {/* CHANGED: Reused translation */}
//                           <option value="Rangpur">
//                             {t(
//                               "homecleanorderform.order_form.customer_information.city_options.rangpur"
//                             )}
//                           </option>{" "}
//                           {/* CHANGED: Reused translation */}
//                           <option value="Maymensingh">
//                             {t(
//                               "homecleanorderform.order_form.customer_information.city_options.maymensingh"
//                             )}
//                           </option>{" "}
//                           {/* CHANGED: Reused translation */}
//                         </select>
//                       </div>
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {/* Address */}
//                           {t(
//                             "electricianorderform.order_form.customer_information.labels.address"
//                           )}{" "}
//                           {/* CHANGED: Updated to new namespace */}
//                         </label>
//                         <textarea
//                           name="address"
//                           className="electricianorder-form-control"
//                           rows="3"
//                           value={orderData.address}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="electricianorder-modal-card">
//                   <div className="electricianorder-card-body">
//                     <h3 className="electricianorder-card-title">
//                       <FontAwesomeIcon icon={faCalendarAlt} />
//                       {/* Booking Details */}
//                       {t(
//                         "electricianorderform.order_form.booking_details.title"
//                       )}{" "}
//                       {/* CHANGED: Updated to new namespace */}
//                     </h3>
//                     <div className="electricianorder-form-grid">
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {/* Date */}
//                           {t(
//                             "electricianorderform.order_form.booking_details.labels.date"
//                           )}{" "}
//                           {/* CHANGED: Updated to new namespace */}
//                         </label>
//                         <input
//                           type="text"
//                           className="electricianorder-form-control"
//                           value={formatDate(formData.date)}
//                           readOnly
//                         />
//                       </div>
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {/* Time */}
//                           {t(
//                             "electricianorderform.order_form.booking_details.labels.time"
//                           )}{" "}
//                           {/* CHANGED: Updated to new namespace */}
//                         </label>
//                         <input
//                           type="text"
//                           className="electricianorder-form-control"
//                           value={formData.time}
//                           readOnly
//                         />
//                       </div>
//                       {!user.penaltyReserved && penalty > 0 ? (
//                         <>
//                           <div className="electricianorder-form-group">
//                             <label className="electricianorder-form-label">
//                               {/* Base Price */}
//                               {t(
//                                 "electricianorderform.order_form.booking_details.labels.base_price"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </label>
//                             <input
//                               type="text"
//                               className="electricianorder-form-control"
//                               value={`${basePrice} tk`}
//                               readOnly
//                             />
//                           </div>
//                           <div className="electricianorder-form-group">
//                             <label className="electricianorder-form-label">
//                               {/* Penalty */}
//                               {t(
//                                 "electricianorderform.order_form.booking_details.labels.penalty"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </label>
//                             <input
//                               type="text"
//                               className="electricianorder-form-control electricianorder-penalty-field"
//                               value={`${penalty} tk`}
//                               readOnly
//                             />
//                           </div>
//                           <div className="electricianorder-form-group">
//                             <label className="electricianorder-form-label">
//                               {/* Total Price */}
//                               {t(
//                                 "electricianorderform.order_form.booking_details.labels.total_price"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </label>
//                             <input
//                               type="text"
//                               className="electricianorder-form-control electricianorder-total-price"
//                               value={`${finalPrice} tk`}
//                               readOnly
//                             />
//                           </div>
//                         </>
//                       ) : (
//                         <div className="electricianorder-form-group">
//                           <label className="electricianorder-form-label">
//                             {/* Total Price */}
//                             {t(
//                               "electricianorderform.order_form.booking_details.labels.total_price"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <input
//                             type="text"
//                             className="electricianorder-form-control electricianorder-total-price"
//                             value={`${finalPrice} tk`}
//                             readOnly
//                           />
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="electricianorder-modal-card">
//                 <div className="electricianorder-card-body">
//                   <h3 className="electricianorder-card-title">
//                     {/* Service Details */}
//                     {t(
//                       "electricianorderform.order_form.service_details.title"
//                     )}{" "}
//                     {/* CHANGED: Updated to new namespace */}
//                   </h3>
//                   <div className="electricianorder-services-section">
//                     <div className="electricianorder-service-category">
//                       <h4 className="electricianorder-category-header">
//                         <FontAwesomeIcon icon={faFan} />
//                         {/* Fans & Regulators */}
//                         {t(
//                           "electricianorderform.order_form.service_details.categories.fans_regulators.title"
//                         )}{" "}
//                         {/* CHANGED: Updated to new namespace */}
//                       </h4>
//                       <div className="electricianorder-services-grid">
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Fan Install/Uninstall */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.fans_regulators.labels.fan_install"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.fanInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.fanInstall}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.fanInstall === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Fan Repair */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.fans_regulators.labels.fan_repair"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.fanRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.fanRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.fanRepair === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Regulator Install/Uninstall */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.fans_regulators.labels.regulator_install"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.regulatorInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.regulatorInstall}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.regulatorInstall === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Regulator Repair */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.fans_regulators.labels.regulator_repair"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.regulatorRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.regulatorRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.regulatorRepair === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="electricianorder-service-category">
//                       <h4 className="electricianorder-category-header">
//                         <FontAwesomeIcon icon={faLightbulb} />
//                         {/* Lights & Sockets */}
//                         {t(
//                           "electricianorderform.order_form.service_details.categories.lights_sockets.title"
//                         )}{" "}
//                         {/* CHANGED: Updated to new namespace */}
//                       </h4>
//                       <div className="electricianorder-services-grid">
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Light Install/Uninstall */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.lights_sockets.labels.light_install"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.lightInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.lightInstall}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.lightInstall === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Light Repair */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.lights_sockets.labels.light_repair"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.lightRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.lightRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.lightRepair === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Socket Install/Uninstall */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.lights_sockets.labels.socket_install"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             // gat
//                             className={`electricianorder-service-value ${
//                               formData.socketInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.socketInstall}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.socketInstall === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Socket Repair */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.lights_sockets.labels.socket_repair"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.socketRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.socketRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.socketRepair === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="electricianorder-service-category">
//                       <h4 className="electricianorder-category-header">
//                         <FontAwesomeIcon icon={faWrench} />
//                         {t(
//                           "electricianorderform.order_form.service_details.categories.misc.title",
//                           "Other Services"
//                         )}
//                       </h4>
//                       <div className="electricianorder-services-grid">
//                         {/* Doorbell */}
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.misc.labels.doorbell_setup",
//                               "Door-bell Setup"
//                             )}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.doorbellSetup > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.doorbellSetup}{" "}
//                             <span className="electricianorder-service-unit">
//                               {t(
//                                 "electricianorderform.order_form.service_details.units",
//                                 "units"
//                               )}
//                             </span>
//                           </div>
//                         </div>

//                         {/* Exhaust Fan */}
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.misc.labels.exhaust_fan_setup",
//                               "Exhaust Fan Setup"
//                             )}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.exhaustFanSetup > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.exhaustFanSetup}{" "}
//                             <span className="electricianorder-service-unit">
//                               {t(
//                                 "electricianorderform.order_form.service_details.units",
//                                 "units"
//                               )}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.misc.labels.exhaust_fan_repair",
//                               "Exhaust Fan Repair"
//                             )}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.exhaustFanRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.exhaustFanRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {t(
//                                 "electricianorderform.order_form.service_details.units",
//                                 "units"
//                               )}
//                             </span>
//                           </div>
//                         </div>

//                         {/* Drill Holes */}
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.misc.labels.drill_wall_holes",
//                               "Drill Wall Holes"
//                             )}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.drillWallHoles > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.drillWallHoles}{" "}
//                             <span className="electricianorder-service-unit">
//                               {t(
//                                 "electricianorderform.order_form.service_details.units",
//                                 "holes"
//                               )}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="electricianorder-service-category">
//                       <h4 className="electricianorder-category-header">
//                         <FontAwesomeIcon icon={faServer} />
//                         {/* Panels & Breakers */}
//                         {t(
//                           "electricianorderform.order_form.service_details.categories.panels_breakers.title"
//                         )}{" "}
//                         {/* CHANGED: Updated to new namespace */}
//                       </h4>
//                       <div className="electricianorder-services-grid">
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Switch Board Repair */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.panels_breakers.labels.switch_board_repair"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.switchBoardRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.switchBoardRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.switchBoardRepair === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* MCB Servicing */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.panels_breakers.labels.mcb_servicing"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.mcbServicing > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.mcbServicing}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.mcbServicing === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* MDB Servicing */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.panels_breakers.labels.mdb_servicing"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.distributionBoardServicing > 0
//                                 ? "has-value"
//                                 : ""
//                             }`}
//                           >
//                             {formData.distributionBoardServicing}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.distributionBoardServicing === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Circuit Breaker Repair */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.panels_breakers.labels.breaker_repair"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.breakerRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.breakerRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.breakerRepair === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="electricianorder-service-category">
//                       <h4 className="electricianorder-category-header">
//                         <FontAwesomeIcon icon={faPlug} />
//                         {/* Wiring & Checkup */}
//                         {t(
//                           "electricianorderform.order_form.service_details.categories.wiring_checkup.title"
//                         )}{" "}
//                         {/* CHANGED: Updated to new namespace */}
//                       </h4>
//                       <div className="electricianorder-services-grid">
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* New Wiring Point */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.wiring_checkup.labels.new_wiring_point"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.newWiringPoint > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.newWiringPoint}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.newWiringPoint === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Electrical Checkup */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.wiring_checkup.labels.electrical_checkup"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.needsCheckup ? "boolean-true" : ""
//                             }`}
//                           >
//                             {/* {formData.needsCheckup ? "Yes" : "No"} */}
//                             {t(
//                               `electricianorderform.order_form.service_details.categories.wiring_checkup.boolean.${
//                                 formData.needsCheckup ? "yes" : "no"
//                               }`
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Full Wiring */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.wiring_checkup.labels.full_wiring"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.fullWiring ? "boolean-true" : ""
//                             }`}
//                           >
//                             {/* {formData.fullWiring ? "Yes" : "No"} */}
//                             {t(
//                               `electricianorderform.order_form.service_details.categories.wiring_checkup.boolean.${
//                                 formData.fullWiring ? "yes" : "no"
//                               }`
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </div>
//                         </div>

//                         {formData.useSameServitor && previousServitorName && (
//                           <div className="electricianorder-service-item electricianorder-rebook-item">
//                             <label className="electricianorder-form-label electricianorder-label-content">
//                               <FontAwesomeIcon
//                                 icon={faCheckCircle}
//                                 className="electricianorder-rebook-icon"
//                               />
//                               {t(
//                                 "electricianorderform.order_form.rebook.label"
//                               )}
//                             </label>
//                             <div className="electricianorder-service-value electricianorder-rebook-value">
//                               <strong>{previousServitorName}</strong>
//                             </div>
//                           </div>
//                         )}

//                         {formData.remarks && (
//                           <div className="electricianorder-service-item electricianorder-remarks-item">
//                             <label className="electricianorder-form-label">
//                               <FontAwesomeIcon
//                                 icon={faCommentAlt}
//                                 className="electricianorder-remarks-icon"
//                               />
//                               {t(
//                                 "electricianorderform.order_form.service_details.categories.wiring_checkup.labels.remarks"
//                               )}
//                             </label>
//                             <div className="electricianorder-service-value has-value electricianorder-remarks-value">
//                               {formData.remarks}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="electricianorder-order-actions">
//               <button
//                 className="electricianorder-btn electricianorder-btn-outline"
//                 onClick={onClose}
//               >
//                 {/* Cancel */}
//                 {t("electricianorderform.order_form.actions.cancel")}{" "}
//                 {/* CHANGED: Updated to new namespace */}
//               </button>
//               <button
//                 className="electricianorder-btn electricianorder-btn-primary"
//                 onClick={handleSubmit}
//               >
//                 <FontAwesomeIcon icon={faTools} />
//                 {/* Place Order */}
//                 {t("electricianorderform.order_form.actions.place_order")}{" "}
//                 {/* CHANGED: Updated to new namespace */}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Order Succesfully placed */}
//       {showSuccessPopup && (
//         <div className="electricianorder-success-popup">
//           <div className="electricianorder-success-popup-content">
//             <h2>
//               {/* Order Successfully Placed! */}
//               {t("electricianorderform.order_form.success_popup.title")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </h2>
//             <p>
//               {/* Thank you for choosing HelpNao. */}
//               {t("electricianorderform.order_form.success_popup.message1")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </p>
//             <p>
//               {/* Your order is now pending confirmation. */}
//               {t("electricianorderform.order_form.success_popup.message2")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </p>
//             <button
//               className="electricianorder-btn electricianorder-btn-primary"
//               onClick={closePopup}
//             >
//               {/* Ok */}
//               {t("electricianorderform.order_form.success_popup.button")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </button>
//           </div>
//         </div>
//       )}

//       {showBlockedPopup && (
//         <div className="electricianorder-success-popup">
//           <div className="electricianorder-success-popup-content">
//             <h2>
//               {/* Account Blocked */}
//               {t("electricianorderform.order_form.blocked_popup.title")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </h2>
//             <p>
//               {/* Your account is blocked due to excessive cancellations. */}
//               {t("electricianorderform.order_form.blocked_popup.message1")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </p>
//             <p>
//               {/* Please contact our support team for assistance. */}
//               {t("electricianorderform.order_form.blocked_popup.message2")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </p>
//             <button
//               className="electricianorder-btn electricianorder-btn-primary"
//               onClick={closeBlockedPopup}
//             >
//               {/* Close */}
//               {t("electricianorderform.order_form.blocked_popup.button")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ElectricianOrderForm;










// ***** New Update with city and Area (21-Sept-2025) ***** //

// import React, { useState, useEffect, useRef } from "react";
// import "./electricianOrderForm.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//   faTimes,
//   faUser,
//   faCalendarAlt,
//   faTools,
//   faFan,
//   faLightbulb,
//   faServer,
//   faPlug,
//   faCommentAlt,
//   faCheckCircle,
//   faWrench,
// } from "@fortawesome/free-solid-svg-icons";
// import axios from "axios";
// import { useTranslation } from "react-i18next";
// import { useNavigate } from "react-router-dom";
// import { URL } from "../../../config";

// const ElectricianOrderForm = ({
//   user,
//   formData,
//   onClose,
//   onSubmit,
//   previousServitorName,
//   serviceId,
// }) => {
//   const { t } = useTranslation();
//   const navigate = useNavigate();

//   // Lists from API
//   const [divisions, setDivisions] = useState([]); // [{Id,name,code}]
//   const [areas, setAreas] = useState([]);         // [{Id,name}]

//   // Selection state (ids) + names (for submit)
//   const [selectedDivisionId, setSelectedDivisionId] = useState(null);
//   const [selectedAreaId, setSelectedAreaId] = useState(null);

//   // Refs for first invalid field focus
//   const divisionRef = useRef(null);
//   const areaRef = useRef(null);
//   const addressRef = useRef(null);

//   const [orderData, setOrderData] = useState({
//     // city: user?.city || "",
//     address: user?.Address || "",
//     mobile: user?.mobile || "",
//   });
//   const [showSuccessPopup, setShowSuccessPopup] = useState(false);
//   const [showForm, setShowForm] = useState(true);
//   const [showBlockedPopup, setShowBlockedPopup] = useState(false);
//   const [errors, setErrors] = useState({ city: "", area: "", address: "" });

//   // For coupons
//   const [couponCode, setCouponCode] = useState("");
//   const [appliedCoupon, setAppliedCoupon] = useState(null);
//   const [couponError, setCouponError] = useState("");
//   const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);


//   const penalty = user && user.penalty ? Number(user.penalty) : 0;
//   const basePrice = Number(formData.price) || 0;
//   // const finalPrice = user.penaltyReserved ? basePrice : basePrice + penalty;

//   const [discountValue, setDiscountValue] = useState(0);

//   const finalPrice = (() => {
//     const total = user.penaltyReserved ? basePrice : basePrice + penalty;
//     return Math.max(0, total - discountValue);
//   })();


//   const clearError = (key) =>
//   setErrors((e) => ({ ...e, [key]: "" }));

//   const validate = () => {
//     const errs = { city: "", area: "", address: "" };
//     if (!selectedDivisionId) errs.city = t("Please select your city");
//     if (!selectedAreaId) errs.area = t("Please select your area");
//     if (!orderData.address?.trim()) errs.address = t("Please enter your address");
//     setErrors(errs);
//     return !errs.city && !errs.area && !errs.address;
//   };

//   useEffect(() => {
//     if (user) {
//       if (user.status === "Blocked") {
//         setShowBlockedPopup(true);
//         setShowForm(false);
//       } else {
//         setOrderData({
//           city: user.city || "",
//           address: user.Address || "",
//           mobile: user.mobile || "",
//         });
//       }
//     }
//   }, [user]);

//   // Disable background scroll when modal is open
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "auto";
//     };
//   }, []);

//   // const handleChange = (e) => {
//   //   const { name, value } = e.target;
//   //   setOrderData((prevData) => ({
//   //     ...prevData,
//   //     [name]: value,
//   //   }));
//   // };


//    // Load active divisions
//   useEffect(() => {
//     (async () => {
//       try {
//         const { data } = await axios.get(`${URL}/locations/divisions`, { params: { countryCode: "BD" } });
//         setDivisions(data || []);

//         // Preselect by user.city (name)
//         if (user?.city) {
//           const match = (data || []).find(d => d.name.toLowerCase() === String(user.city).toLowerCase());
//           if (match) setSelectedDivisionId(match.Id);
//         }
//       } catch (e) {
//         console.error("Failed to load divisions:", e);
//       }
//     })();
//   }, [user?.city]);

//   // Load active areas when division changes
//   useEffect(() => {
//     (async () => {
//       if (!selectedDivisionId) {
//         setAreas([]);
//         setSelectedAreaId(null);
//         return;
//       }
//       try {
//         const { data } = await axios.get(`${URL}/locations/areas`, { params: { divisionId: selectedDivisionId } });
//         setAreas(data || []);

//         // Preselect by user.area (name)
//         if (user?.area) {
//           const match = (data || []).find(a => a.name.toLowerCase() === String(user.area).toLowerCase());
//           if (match) setSelectedAreaId(match.Id);
//         } else {
//           setSelectedAreaId(null);
//         }
//       } catch (e) {
//         console.error("Failed to load areas:", e);
//         setAreas([]);
//         setSelectedAreaId(null);
//       }
//     })();
//   }, [selectedDivisionId, user?.area]);

//   const handleDivisionChange = (e) => {
//     const id = e.target.value ? Number(e.target.value) : null;
//     setSelectedDivisionId(id);
//     clearError("city");
//   };

//   const handleAreaChange = (e) => {
//     const id = e.target.value ? Number(e.target.value) : null;
//     setSelectedAreaId(id);
//     clearError("area");
//   };

//   const handleAddressChange = (e) => {
//     setOrderData(prev => ({ ...prev, address: e.target.value }));
//     if (e.target.value?.trim()) clearError("address");
//   };


//   const formatDate = (dateStr) => {
//     const dateObj = new Date(dateStr);
//     const day = dateObj.getDate();
//     const month = dateObj.toLocaleString("default", { month: "short" });
//     const year = dateObj.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validate()) {
//       // focus + scroll to the first invalid
//       if (!selectedDivisionId && divisionRef.current) {
//         divisionRef.current.focus();
//         divisionRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
//       } else if (!selectedAreaId && areaRef.current) {
//         areaRef.current.focus();
//         areaRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
//       } else if (!orderData.address?.trim() && addressRef.current) {
//         addressRef.current.focus();
//         addressRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
//       }
//       return;
//     }

//     const selectedDivision = divisions.find(d => d.Id === selectedDivisionId);
//     const selectedArea = areas.find(a => a.Id === selectedAreaId);

//     // if (!selectedDivision) return alert(t("Please select your city"));
//     // if (!selectedArea) return alert(t("Please select your area"));
//     // if (!orderData.address?.trim()) return alert(t("Please provide your address"));

//     // Build payload: names (server will validate against Location)
//     const finalOrderData = {
//       userId: user.Id,

//       usercity: selectedDivision.name, // division name
//       userarea: selectedArea.name,     // area name
//       useraddress: orderData.address,  // address string

//       // original service fields
//       fanInstall: formData.fanInstall,
//       lightInstall: formData.lightInstall,
//       fanRepair: formData.fanRepair,
//       lightRepair: formData.lightRepair,

//       doorbellSetup: formData.doorbellSetup,
//       exhaustFanSetup: formData.exhaustFanSetup,
//       exhaustFanRepair: formData.exhaustFanRepair,
//       drillWallHoles: formData.drillWallHoles,

//       switchBoardRepair: formData.switchBoardRepair,
//       distributionBoardServicing: formData.distributionBoardServicing,
//       mcbServicing: formData.mcbServicing,

//       regulatorInstall: formData.regulatorInstall,
//       regulatorRepair: formData.regulatorRepair,
//       socketInstall: formData.socketInstall,
//       socketRepair: formData.socketRepair,
//       breakerRepair: formData.breakerRepair,
//       newWiringPoint: formData.newWiringPoint,
//       coilRepair: formData.coilRepair,
//       // fullWiring: formData.fullWiring,
//       electricalCheckup: formData.needsCheckup,

//       remarks: formData.remarks,
//       // price: formData.price,
//       price: finalPrice,

//       date: formData.date,
//       time: formData.time,
//       status: "pending",

//       // Rebook
//       useSameServitor: formData.useSameServitor,
//       previousServitorId: formData.servitor_id,

//       serviceId: serviceId || 1,
//     };

//     if (appliedCoupon) {
//       finalOrderData.appliedCoupon = appliedCoupon;
//       finalOrderData.discountValue = discountValue;
//     }

//     try {
//       const response = await axios.post(`${URL}/electrician`, finalOrderData);
//       console.log("Order placed successfully:", response.data);
//       setShowForm(false);
//       setShowSuccessPopup(true);
//     } catch (error) {
//       console.error("Error placing order:", error);
//       alert(error?.response?.data?.message || "Failed to place order");
//     }
//   };


//   // === Coupon handling ===
//   const handleApplyCoupon = async () => {
//     if (!couponCode.trim()) {
//       setCouponError("Please enter a coupon code.");
//       return;
//     }
//     setIsApplyingCoupon(true);
//     setCouponError("");
//     try {
//       const res = await axios.post(`${URL}/usercoupon/apply`, {
//         userId: user.Id,
//         code: couponCode.trim(),
//       });
//       const { discountValue, code } = res.data;
//       setAppliedCoupon(code);
//       setDiscountValue(discountValue);
//       setCouponError("");
//     } catch (err) {
//       setAppliedCoupon(null);
//       setDiscountValue(0);
//       setCouponError(err?.response?.data?.message || "Invalid or expired coupon.");
//     } finally {
//       setIsApplyingCoupon(false);
//     }
//   };

//   const handleRemoveCoupon = async () => {
//     // try {
//     //   await axios.post(`${URL}/usercoupon/remove`, {
//     //     userId: user.Id,
//     //     code: appliedCoupon,
//     //   });
//     // } catch (err) {
//     //   console.warn("Coupon removal failed (non-blocking):", err);
//     // }
//     setAppliedCoupon(null);
//     setDiscountValue(0);
//     setCouponCode("");
//     setCouponError("");
//   };


//   const closePopup = () => {
//     setShowSuccessPopup(false);
//     onClose();
//     onSubmit();
//     navigate("/profile/orderhistory");
//   };

//   const closeBlockedPopup = () => {
//     setShowBlockedPopup(false);
//     onClose();
//   };

//   return (
//     <>
//       {showForm && (
//         <div className="electricianorder-modal-backdrop">
//           <div className="electricianorder-modal-content">
//             <div className="electricianorder-modal-header">
//               <h2 className="electricianorder-modal-title">
//                 {/* Order Details */}
//                 {t("electricianorderform.order_form.modal.title")}{" "}
//                 {/* CHANGED: Updated to new namespace */}
//               </h2>
//               <button
//                 className="electricianorder-modal-close"
//                 onClick={onClose}
//                 aria-label={t(
//                   "electricianorderform.order_form.modal.close_button"
//                 )}
//               >
//                 <FontAwesomeIcon icon={faTimes} />
//               </button>
//             </div>

//             <div className="electricianorder-modal-body">
//               <div className="electricianorder-two-column-grid">
//                 <div className="electricianorder-modal-card">
//                   <div className="electricianorder-card-body">
//                     <h3 className="electricianorder-card-title">
//                       <FontAwesomeIcon icon={faUser} />
//                       {/* Customer Information */}
//                       {t(
//                         "electricianorderform.order_form.customer_information.title"
//                       )}{" "}
//                       {/* CHANGED: Updated to new namespace */}
//                     </h3>
//                     <div className="electricianorder-form-grid">
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {/* Name */}
//                           {t(
//                             "electricianorderform.order_form.customer_information.labels.name"
//                           )}{" "}
//                           {/* CHANGED: Updated to new namespace */}
//                         </label>
//                         <input
//                           type="text"
//                           className="electricianorder-form-control"
//                           value={`${user.FirstName} ${user.LastName}`}
//                           readOnly
//                         />
//                       </div>
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {/* Mobile */}
//                           {t(
//                             "electricianorderform.order_form.customer_information.labels.mobile"
//                           )}{" "}
//                           {/* CHANGED: Updated to new namespace */}
//                         </label>
//                         <input
//                           type="text"
//                           className="electricianorder-form-control"
//                           value={`${orderData.mobile}`}
//                           readOnly
//                         />
//                       </div>
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {/* City */}
//                           {t(
//                             "electricianorderform.order_form.customer_information.labels.city"
//                           )}{" "}
//                           {/* CHANGED: Updated to new namespace */}
//                         </label>
//                         <select
//                           className="electricianorder-form-control"
//                           value={selectedDivisionId || ""}
//                           onChange={handleDivisionChange}
//                           onBlur={validate}
//                           ref={divisionRef}
//                           aria-invalid={Boolean(errors.city)}
//                           aria-describedby={errors.city ? "city-error" : undefined}
//                         >
//                           {/* <option value="">
//                              {t('electricianorderform.order_form.customer_information.labels.city_placeholder')}
//                            </option> */}
//                           {/* {Object.entries(t('electricianorderform.order_form.customer_information.city_options', { returnObjects: true })).map(([key, value]) => (
//                              <option key={key} value={value}>{value}</option>
//                            ))} */}
//                           <option value="">
//                             {t("plumberorderform.order_form.customer_information.labels.city_placeholder")}
//                           </option>
//                           {divisions.map(d => (
//                             <option key={d.Id} value={d.Id}>{d.name}</option>
//                           ))}
//                         </select>
//                         {errors.city && (
//                           <div id="city-error" className="field-error">{errors.city}</div>
//                         )}      
//                       </div>

//                       {/* Area */}
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {t("electricianorderform.order_form.customer_information.labels.area", "Area")}
//                         </label>
//                         <select
//                           className="electricianorder-form-control"
//                           value={selectedAreaId || ""}
//                           onChange={handleAreaChange}
//                           onBlur={validate}
//                           disabled={!selectedDivisionId}
//                           aria-invalid={Boolean(errors.area)}
//                           aria-describedby={errors.area ? "area-error" : undefined}
//                           ref={areaRef}
//                         >
//                           <option value="">
//                             {!selectedDivisionId ? t("Select City first") : t("Select Area")}
//                           </option>
//                           {areas.map(a => (
//                             <option key={a.Id} value={a.Id}>{a.name}</option>
//                           ))}
//                         </select>

//                         {errors.area && (
//                           <div id="area-error" className="field-error">{errors.area}</div>
//                         )}

//                       </div>

//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {/* Address */}
//                           {t(
//                             "electricianorderform.order_form.customer_information.labels.address"
//                           )}{" "}
//                           {/* CHANGED: Updated to new namespace */}
//                         </label>
//                         <textarea
//                           name="address"
//                           className="electricianorder-form-control"
//                           rows="3"
//                           value={orderData.address}
//                           onChange={handleAddressChange}
//                           onBlur={validate}
//                           aria-invalid={Boolean(errors.address)}
//                           aria-describedby={errors.address ? "address-error" : undefined}
//                           ref={addressRef}
//                         />
//                         {errors.address && (
//                           <div id="address-error" className="field-error">{errors.address}</div>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="electricianorder-modal-card">
//                   <div className="electricianorder-card-body">
//                     <h3 className="electricianorder-card-title">
//                       <FontAwesomeIcon icon={faCalendarAlt} />
//                       {/* Booking Details */}
//                       {t(
//                         "electricianorderform.order_form.booking_details.title"
//                       )}{" "}
//                       {/* CHANGED: Updated to new namespace */}
//                     </h3>
//                     <div className="electricianorder-form-grid">
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {/* Date */}
//                           {t(
//                             "electricianorderform.order_form.booking_details.labels.date"
//                           )}{" "}
//                           {/* CHANGED: Updated to new namespace */}
//                         </label>
//                         <input
//                           type="text"
//                           className="electricianorder-form-control"
//                           value={formatDate(formData.date)}
//                           readOnly
//                         />
//                       </div>
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {/* Time */}
//                           {t(
//                             "electricianorderform.order_form.booking_details.labels.time"
//                           )}{" "}
//                           {/* CHANGED: Updated to new namespace */}
//                         </label>
//                         <input
//                           type="text"
//                           className="electricianorder-form-control"
//                           value={formData.time}
//                           readOnly
//                         />
//                       </div>
//                       {!user.penaltyReserved && penalty > 0 ? (
//                         <>
//                           <div className="electricianorder-form-group">
//                             <label className="electricianorder-form-label">
//                               {/* Base Price */}
//                               {t(
//                                 "electricianorderform.order_form.booking_details.labels.base_price"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </label>
//                             <input
//                               type="text"
//                               className="electricianorder-form-control"
//                               value={`${basePrice} tk`}
//                               readOnly
//                             />
//                           </div>
//                           <div className="electricianorder-form-group">
//                             <label className="electricianorder-form-label">
//                               {/* Penalty */}
//                               {t(
//                                 "electricianorderform.order_form.booking_details.labels.penalty"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </label>
//                             <input
//                               type="text"
//                               className="electricianorder-form-control electricianorder-penalty-field"
//                               value={`${penalty} tk`}
//                               readOnly
//                             />
//                           </div>

//                           {/* <div className="electricianorder-form-group">
//                             <label className="electricianorder-form-label">
//                               {t(
//                                 "electricianorderform.order_form.booking_details.labels.total_price"
//                               )}{" "}
//                             </label>
//                             <input
//                               type="text"
//                               className="electricianorder-form-control electricianorder-total-price"
//                               value={`${finalPrice} tk`}
//                               readOnly
//                             />
//                           </div> */}


//                           <div className="electricianorder-form-group">
//                             <label className="electricianorder-form-label">
//                               {t("electricianorderform.order_form.booking_details.labels.total_price")}
//                             </label>

//                             {appliedCoupon ? (
//                               <div className="electricianorder-price-discounted">
//                                 <div className="electricianorder-original-price">
//                                   {user.penaltyReserved
//                                     ? `${basePrice} tk`
//                                     : `${basePrice + penalty} tk`}
//                                 </div>

//                                 <div className="electricianorder-final-price">
//                                   <span className="discounted-price">{finalPrice} tk</span>
//                                   <small className="discount-label">({discountValue} tk off)</small>
//                                 </div>
//                               </div>
//                             ) : (
//                               <input
//                                 type="text"
//                                 className="electricianorder-form-control electricianorder-total-price"
//                                 value={`${finalPrice} tk`}
//                                 readOnly
//                               />
//                             )}
//                           </div>

//                         </>
//                       ) : (
//                         // <div className="electricianorder-form-group">
//                         //   <label className="electricianorder-form-label">
//                         //     {/* Total Price */}
//                         //     {t(
//                         //       "electricianorderform.order_form.booking_details.labels.total_price"
//                         //     )}{" "}
//                         //     {/* CHANGED: Updated to new namespace */}
//                         //   </label>
//                         //   <input
//                         //     type="text"
//                         //     className="electricianorder-form-control electricianorder-total-price"
//                         //     value={`${finalPrice} tk`}
//                         //     readOnly
//                         //   />
//                         // </div>

//                         // New design for dicount
//                         <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {t("electricianorderform.order_form.booking_details.labels.total_price")}
//                         </label>

//                         {appliedCoupon ? (
//                           <div className="electricianorder-price-discounted">
//                             <div className="electricianorder-original-price">
//                               {user.penaltyReserved
//                                 ? `${basePrice} tk`
//                                 : `${basePrice + penalty} tk`}
//                             </div>

//                             <div className="electricianorder-final-price">
//                               <span className="discounted-price">{finalPrice} tk</span>
//                               <small className="discount-label">({discountValue} tk off)</small>
//                             </div>
//                           </div>
//                         ) : (
//                           <input
//                             type="text"
//                             className="electricianorder-form-control electricianorder-total-price"
//                             value={`${finalPrice} tk`}
//                             readOnly
//                           />
//                         )}
//                       </div>

//                       )}


//                       {/* Coupon Code */}
//                       <div className="electricianorder-form-group">
//                         <label className="electricianorder-form-label">
//                           {t("electricianorderform.order_form.booking_details.labels.coupon", "Coupon Code")}
//                         </label>

//                         {appliedCoupon ? (
//                           <div className="electricianorder-coupon-applied">
//                             {/* <p>
//                               ✅ Applied: <strong>{appliedCoupon}</strong>
//                             </p> */}
//                              <p>
//                                 ✅ {t("electricianorderform.coupon.applied", "Applied")}:{" "}
//                                 <strong>{appliedCoupon}</strong>
//                               </p>
//                             <button
//                               type="button"
//                               // className="electricianorder-btn electricianorder-btn-outline"
//                               className="electricianorder-btn-removecoupon"
//                               onClick={handleRemoveCoupon}
//                             >
//                               {/* Remove */}
//                               {t("electricianorderform.coupon.remove", "Remove")}
//                             </button>
//                           </div>
//                         ) : (
//                           <div className="electricianorder-coupon-input-row">
//                             <input
//                               type="text"
//                               value={couponCode}
//                               onChange={(e) => setCouponCode(e.target.value)}
//                               placeholder={t("electricianorderform.order_form.booking_details.labels.coupon_placeholder", "Enter coupon")}
//                               className="electricianorder-form-control"
//                               disabled={isApplyingCoupon}
//                             />
//                             <button
//                               type="button"
//                               // className="electricianorder-btn electricianorder-btn-primary"
//                               className="electricianorder-btn-applycoupon"
//                               onClick={handleApplyCoupon}
//                               disabled={isApplyingCoupon}
//                             >
//                               {/* {isApplyingCoupon ? "Applying..." : "Apply"} */}
//                               {isApplyingCoupon
//                                 ? t("electricianorderform.coupon.applying", "Applying...")
//                                 : t("electricianorderform.coupon.apply", "Apply")}
//                             </button>
//                           </div>
//                         )}

//                         {/* {couponError && <div className="field-error">{couponError}</div>} */}

//                         {couponError && (
//                           <div className="field-error">
//                             {t("electricianorderform.coupon.invalid", couponError)}
//                           </div>
//                         )}

//                       </div>


//                     </div>
//                   </div>
//                 </div>
//               </div>

//               <div className="electricianorder-modal-card">
//                 <div className="electricianorder-card-body">
//                   <h3 className="electricianorder-card-title">
//                     {/* Service Details */}
//                     {t(
//                       "electricianorderform.order_form.service_details.title"
//                     )}{" "}
//                     {/* CHANGED: Updated to new namespace */}
//                   </h3>
//                   <div className="electricianorder-services-section">
//                     <div className="electricianorder-service-category">
//                       <h4 className="electricianorder-category-header">
//                         <FontAwesomeIcon icon={faFan} />
//                         {/* Fans & Regulators */}
//                         {t(
//                           "electricianorderform.order_form.service_details.categories.fans_regulators.title"
//                         )}{" "}
//                         {/* CHANGED: Updated to new namespace */}
//                       </h4>
//                       <div className="electricianorder-services-grid">
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Fan Install/Uninstall */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.fans_regulators.labels.fan_install"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.fanInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.fanInstall}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.fanInstall === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Fan Repair */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.fans_regulators.labels.fan_repair"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.fanRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.fanRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.fanRepair === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Regulator Install/Uninstall */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.fans_regulators.labels.regulator_install"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.regulatorInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.regulatorInstall}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.regulatorInstall === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Regulator Repair */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.fans_regulators.labels.regulator_repair"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.regulatorRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.regulatorRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.regulatorRepair === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="electricianorder-service-category">
//                       <h4 className="electricianorder-category-header">
//                         <FontAwesomeIcon icon={faLightbulb} />
//                         {/* Lights & Sockets */}
//                         {t(
//                           "electricianorderform.order_form.service_details.categories.lights_sockets.title"
//                         )}{" "}
//                         {/* CHANGED: Updated to new namespace */}
//                       </h4>
//                       <div className="electricianorder-services-grid">
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Light Install/Uninstall */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.lights_sockets.labels.light_install"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.lightInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.lightInstall}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.lightInstall === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Light Repair */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.lights_sockets.labels.light_repair"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.lightRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.lightRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.lightRepair === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Socket Install/Uninstall */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.lights_sockets.labels.socket_install"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             // gat
//                             className={`electricianorder-service-value ${
//                               formData.socketInstall > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.socketInstall}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.socketInstall === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Socket Repair */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.lights_sockets.labels.socket_repair"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.socketRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.socketRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.socketRepair === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="electricianorder-service-category">
//                       <h4 className="electricianorder-category-header">
//                         <FontAwesomeIcon icon={faWrench} />
//                         {t(
//                           "electricianorderform.order_form.service_details.categories.misc.title",
//                           "Other Services"
//                         )}
//                       </h4>
//                       <div className="electricianorder-services-grid">
//                         {/* Doorbell */}
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.misc.labels.doorbell_setup",
//                               "Door-bell Setup"
//                             )}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.doorbellSetup > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.doorbellSetup}{" "}
//                             <span className="electricianorder-service-unit">
//                               {t(
//                                 "electricianorderform.order_form.service_details.units",
//                                 "units"
//                               )}
//                             </span>
//                           </div>
//                         </div>

//                         {/* Exhaust Fan */}
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.misc.labels.exhaust_fan_setup",
//                               "Exhaust Fan Setup"
//                             )}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.exhaustFanSetup > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.exhaustFanSetup}{" "}
//                             <span className="electricianorder-service-unit">
//                               {t(
//                                 "electricianorderform.order_form.service_details.units",
//                                 "units"
//                               )}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.misc.labels.exhaust_fan_repair",
//                               "Exhaust Fan Repair"
//                             )}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.exhaustFanRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.exhaustFanRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {t(
//                                 "electricianorderform.order_form.service_details.units",
//                                 "units"
//                               )}
//                             </span>
//                           </div>
//                         </div>

//                         {/* Drill Holes */}
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.misc.labels.drill_wall_holes",
//                               "Drill Wall Holes"
//                             )}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.drillWallHoles > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.drillWallHoles}{" "}
//                             <span className="electricianorder-service-unit">
//                               {t(
//                                 "electricianorderform.order_form.service_details.units",
//                                 "holes"
//                               )}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="electricianorder-service-category">
//                       <h4 className="electricianorder-category-header">
//                         <FontAwesomeIcon icon={faServer} />
//                         {/* Panels & Breakers */}
//                         {t(
//                           "electricianorderform.order_form.service_details.categories.panels_breakers.title"
//                         )}{" "}
//                         {/* CHANGED: Updated to new namespace */}
//                       </h4>
//                       <div className="electricianorder-services-grid">
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Switch Board Repair */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.panels_breakers.labels.switch_board_repair"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.switchBoardRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.switchBoardRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.switchBoardRepair === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* MCB Servicing */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.panels_breakers.labels.mcb_servicing"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.mcbServicing > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.mcbServicing}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.mcbServicing === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* MDB Servicing */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.panels_breakers.labels.mdb_servicing"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.distributionBoardServicing > 0
//                                 ? "has-value"
//                                 : ""
//                             }`}
//                           >
//                             {formData.distributionBoardServicing}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.distributionBoardServicing === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Circuit Breaker Repair */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.panels_breakers.labels.breaker_repair"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.breakerRepair > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.breakerRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.breakerRepair === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                       </div>
//                     </div>

//                     <div className="electricianorder-service-category">
//                       <h4 className="electricianorder-category-header">
//                         <FontAwesomeIcon icon={faPlug} />
//                         {/* Wiring & Checkup */}
//                         {t(
//                           "electricianorderform.order_form.service_details.categories.wiring_checkup.title"
//                         )}{" "}
//                         {/* CHANGED: Updated to new namespace */}
//                       </h4>
//                       <div className="electricianorder-services-grid">
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* New Wiring Point */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.wiring_checkup.labels.new_wiring_point"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.newWiringPoint > 0 ? "has-value" : ""
//                             }`}
//                           >
//                             {formData.newWiringPoint}{" "}
//                             <span className="electricianorder-service-unit">
//                               {/* units */}
//                               {t(
//                                 formData.newWiringPoint === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}{" "}
//                               {/* CHANGED: Updated to new namespace */}
//                             </span>
//                           </div>
//                         </div>
//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {/* Electrical Checkup */}
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.wiring_checkup.labels.electrical_checkup"
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.needsCheckup ? "boolean-true" : ""
//                             }`}
//                           >
//                             {/* {formData.needsCheckup ? "Yes" : "No"} */}
//                             {t(
//                               `electricianorderform.order_form.service_details.categories.wiring_checkup.boolean.${
//                                 formData.needsCheckup ? "yes" : "no"
//                               }`
//                             )}{" "}
//                             {/* CHANGED: Updated to new namespace */}
//                           </div>
//                         </div>

//                         <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {t("electricianorderform.order_form.service_details.categories.wiring_checkup.labels.coil_repair", "Coil Repair")}
//                           </label>
//                           <div className={`electricianorder-service-value ${formData.coilRepair > 0 ? "has-value" : ""}`}>
//                             {formData.coilRepair}{" "}
//                             <span className="electricianorder-service-unit">
//                               {t(
//                                 formData.coilRepair === 1
//                                   ? "electricianorderform.order_form.service_details.unit"
//                                   : "electricianorderform.order_form.service_details.units"
//                               )}
//                             </span>
//                           </div>
//                         </div>
//                             {/* Full Wiring */}
//                         {/* <div className="electricianorder-service-item">
//                           <label className="electricianorder-form-label">
//                             {t(
//                               "electricianorderform.order_form.service_details.categories.wiring_checkup.labels.full_wiring"
//                             )}{" "}
//                           </label>
//                           <div
//                             className={`electricianorder-service-value ${
//                               formData.fullWiring ? "boolean-true" : ""
//                             }`}
//                           >
//                             {t(
//                               `electricianorderform.order_form.service_details.categories.wiring_checkup.boolean.${
//                                 formData.fullWiring ? "yes" : "no"
//                               }`
//                             )}{" "}
//                           </div>
//                         </div> */}

//                         {formData.useSameServitor && previousServitorName && (
//                           <div className="electricianorder-service-item electricianorder-rebook-item">
//                             <label className="electricianorder-form-label electricianorder-label-content">
//                               <FontAwesomeIcon
//                                 icon={faCheckCircle}
//                                 className="electricianorder-rebook-icon"
//                               />
//                               {t(
//                                 "electricianorderform.order_form.rebook.label"
//                               )}
//                             </label>
//                             <div className="electricianorder-service-value electricianorder-rebook-value">
//                               <strong>{previousServitorName}</strong>
//                             </div>
//                           </div>
//                         )}

//                         {formData.remarks && (
//                           <div className="electricianorder-service-item electricianorder-remarks-item">
//                             <label className="electricianorder-form-label">
//                               <FontAwesomeIcon
//                                 icon={faCommentAlt}
//                                 className="electricianorder-remarks-icon"
//                               />
//                               {t(
//                                 "electricianorderform.order_form.service_details.categories.wiring_checkup.labels.remarks"
//                               )}
//                             </label>
//                             <div className="electricianorder-service-value has-value electricianorder-remarks-value">
//                               {formData.remarks}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="electricianorder-order-actions">
//               <button
//                 className="electricianorder-btn electricianorder-btn-outline"
//                 onClick={onClose}
//               >
//                 {/* Cancel */}
//                 {t("electricianorderform.order_form.actions.cancel")}{" "}
//                 {/* CHANGED: Updated to new namespace */}
//               </button>
//               <button
//                 className="electricianorder-btn electricianorder-btn-primary"
//                 onClick={handleSubmit}
//               >
//                 <FontAwesomeIcon icon={faTools} />
//                 {/* Place Order */}
//                 {t("electricianorderform.order_form.actions.place_order")}{" "}
//                 {/* CHANGED: Updated to new namespace */}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Order Succesfully placed */}
//       {showSuccessPopup && (
//         <div className="electricianorder-success-popup">
//           <div className="electricianorder-success-popup-content">
//             <h2>
//               {/* Order Successfully Placed! */}
//               {t("electricianorderform.order_form.success_popup.title")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </h2>
//             <p>
//               {/* Thank you for choosing HelpNao. */}
//               {t("electricianorderform.order_form.success_popup.message1")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </p>
//             <p>
//               {/* Your order is now pending confirmation. */}
//               {t("electricianorderform.order_form.success_popup.message2")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </p>
//             <button
//               className="electricianorder-btn electricianorder-btn-primary"
//               onClick={closePopup}
//             >
//               {/* Ok */}
//               {t("electricianorderform.order_form.success_popup.button")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </button>
//           </div>
//         </div>
//       )}

//       {showBlockedPopup && (
//         <div className="electricianorder-success-popup">
//           <div className="electricianorder-success-popup-content">
//             <h2>
//               {/* Account Blocked */}
//               {t("electricianorderform.order_form.blocked_popup.title")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </h2>
//             <p>
//               {/* Your account is blocked due to excessive cancellations. */}
//               {t("electricianorderform.order_form.blocked_popup.message1")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </p>
//             <p>
//               {/* Please contact our support team for assistance. */}
//               {t("electricianorderform.order_form.blocked_popup.message2")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </p>
//             <button
//               className="electricianorder-btn electricianorder-btn-primary"
//               onClick={closeBlockedPopup}
//             >
//               {/* Close */}
//               {t("electricianorderform.order_form.blocked_popup.button")}{" "}
//               {/* CHANGED: Updated to new namespace */}
//             </button>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ElectricianOrderForm;







// ***** Update with new data and features (22-Oct-2025) ***** //
import React, { useState, useEffect, useRef } from "react";
import "./electricianOrderForm.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimes,
  faUser,
  faCalendarAlt,
  faTools,
  faFan,
  faLightbulb,
  faServer,
  faPlug,
  faCommentAlt,
  faCheckCircle,
  faWrench,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { URL } from "../../../config";

const ElectricianOrderForm = ({
  user,
  formData,
  onClose,
  onSubmit,
  previousServitorName,
  serviceId,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // Lists from API
  const [divisions, setDivisions] = useState([]); // [{Id,name,code}]
  const [areas, setAreas] = useState([]); // [{Id,name}]

  // Selection state (ids) + names (for submit)
  const [selectedDivisionId, setSelectedDivisionId] = useState(null);
  const [selectedAreaId, setSelectedAreaId] = useState(null);

  // Refs for first invalid field focus
  const divisionRef = useRef(null);
  const areaRef = useRef(null);
  const addressRef = useRef(null);

  const [orderData, setOrderData] = useState({
    // city: user?.city || "",
    address: user?.Address || "",
    mobile: user?.mobile || "",
  });
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [showBlockedPopup, setShowBlockedPopup] = useState(false);
  const [errors, setErrors] = useState({ city: "", area: "", address: "" });

  // For coupons
  const [couponCode, setCouponCode] = useState("");
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [couponError, setCouponError] = useState("");
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);


  // const penalty = user && user.penalty ? Number(user.penalty) : 0;
  const basePrice = Number(formData.price) || 0;
  // const finalPrice = user.penaltyReserved ? basePrice : basePrice + penalty;

  const [discountValue, setDiscountValue] = useState(0);

  // const finalPrice = (() => {
  //   const total = user.penaltyReserved ? basePrice : basePrice + penalty;
  //   return Math.max(0, total - discountValue);
  // })();

  const finalPrice = (() => {
    return Math.max(0, basePrice - discountValue);
  })();

  const clearError = (key) => setErrors((e) => ({ ...e, [key]: "" }));

  const validate = () => {
    const errs = { city: "", area: "", address: "" };
    if (!selectedDivisionId) errs.city = t("Please select your city");
    if (!selectedAreaId) errs.area = t("Please select your area");
    if (!orderData.address?.trim())
      errs.address = t("Please enter your address");
    setErrors(errs);
    return !errs.city && !errs.area && !errs.address;
  };

  useEffect(() => {
    if (user) {
      if (user.status === "Blocked") {
        setShowBlockedPopup(true);
        setShowForm(false);
      } else {
        setOrderData({
          city: user.city || "",
          address: user.Address || "",
          mobile: user.mobile || "",
        });
      }
    }
  }, [user]);

  // Disable background scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setOrderData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };

  // Load active divisions
  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${URL}/locations/divisions`, {
          params: { countryCode: "BD" },
        });
        setDivisions(data || []);

        // Preselect by user.city (name)
        if (user?.city) {
          const match = (data || []).find(
            (d) => d.name.toLowerCase() === String(user.city).toLowerCase()
          );
          if (match) setSelectedDivisionId(match.Id);
        }
      } catch (e) {
        console.error("Failed to load divisions:", e);
      }
    })();
  }, [user?.city]);

  // Load active areas when division changes
  useEffect(() => {
    (async () => {
      if (!selectedDivisionId) {
        setAreas([]);
        setSelectedAreaId(null);
        return;
      }
      try {
        const { data } = await axios.get(`${URL}/locations/areas`, {
          params: { divisionId: selectedDivisionId },
        });
        setAreas(data || []);

        // Preselect by user.area (name)
        if (user?.area) {
          const match = (data || []).find(
            (a) => a.name.toLowerCase() === String(user.area).toLowerCase()
          );
          if (match) setSelectedAreaId(match.Id);
        } else {
          setSelectedAreaId(null);
        }
      } catch (e) {
        console.error("Failed to load areas:", e);
        setAreas([]);
        setSelectedAreaId(null);
      }
    })();
  }, [selectedDivisionId, user?.area]);

  const handleDivisionChange = (e) => {
    const id = e.target.value ? Number(e.target.value) : null;
    setSelectedDivisionId(id);
    clearError("city");
  };

  const handleAreaChange = (e) => {
    const id = e.target.value ? Number(e.target.value) : null;
    setSelectedAreaId(id);
    clearError("area");
  };

  const handleAddressChange = (e) => {
    setOrderData((prev) => ({ ...prev, address: e.target.value }));
    if (e.target.value?.trim()) clearError("address");
  };

  const formatDate = (dateStr) => {
    const dateObj = new Date(dateStr);
    const day = dateObj.getDate();
    const month = dateObj.toLocaleString("default", { month: "short" });
    const year = dateObj.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    if (!validate()) {
      // focus + scroll to the first invalid
      if (!selectedDivisionId && divisionRef.current) {
        divisionRef.current.focus();
        divisionRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      } else if (!selectedAreaId && areaRef.current) {
        areaRef.current.focus();
        areaRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      } else if (!orderData.address?.trim() && addressRef.current) {
        addressRef.current.focus();
        addressRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
      return;
    }

    setIsSubmitting(true);

    const selectedDivision = divisions.find((d) => d.Id === selectedDivisionId);
    const selectedArea = areas.find((a) => a.Id === selectedAreaId);

    // if (!selectedDivision) return alert(t("Please select your city"));
    // if (!selectedArea) return alert(t("Please select your area"));
    // if (!orderData.address?.trim()) return alert(t("Please provide your address"));

    // Build payload: names (server will validate against Location)
    const finalOrderData = {
      userId: user.Id,

      usercity: selectedDivision.name, // division name
      userarea: selectedArea.name, // area name
      useraddress: orderData.address, // address string

      // original service fields
      // fanInstall: formData.fanInstall,
      // lightInstall: formData.lightInstall,
      // fanRepair: formData.fanRepair,
      // lightRepair: formData.lightRepair,

      // doorbellSetup: formData.doorbellSetup,
      // exhaustFanSetup: formData.exhaustFanSetup,
      // exhaustFanRepair: formData.exhaustFanRepair,
      // drillWallHoles: formData.drillWallHoles,

      // switchBoardRepair: formData.switchBoardRepair,
      // distributionBoardServicing: formData.distributionBoardServicing,
      // mcbServicing: formData.mcbServicing,

      // regulatorInstall: formData.regulatorInstall,
      // regulatorRepair: formData.regulatorRepair,
      // socketInstall: formData.socketInstall,
      // socketRepair: formData.socketRepair,
      // breakerRepair: formData.breakerRepair,
      // newWiringPoint: formData.newWiringPoint,
      // coilRepair: formData.coilRepair,
      // // fullWiring: formData.fullWiring,
      // electricalCheckup: formData.needsCheckup,

      newCeilingFanInstallation: formData.new_ceiling_fan_installation,
      ceilingFanInstallation: formData.ceiling_fan_installation,
      ceilingFanUninstallation: formData.ceiling_fan_uninstallation,
      fanCoilNewWinding: formData.fan_coil_new_winding,
      fanCoilRepair: formData.fan_coil_repair,
      capacitorSetup: formData.capacitor_setup,

      lightInstallation: formData.light_installation,
      lightRepair: formData.light_repair,

      exhaustFanInstallation: formData.exhaust_fan_installation,
      exhaustFanCleaning: formData.exhaust_fan_cleaning,

      switchSetup: formData.switch_setup,
      socketSetup: formData.socket_setup,
      regulatorSetup: formData.regulator_setup,

      newWiringPoint: formData.new_wiring_point,
      mainCircuitBoardSetup: formData.main_circuit_board_setup,

      doorbellInstallation: formData.doorbell_installation,
      drillHoleService: formData.drill_hole_service,

      ipsInstallationExistingLine: formData.ips_installation_existing_line,
      ipsNewLineInstallation: formData.ips_new_line_installation,

      electricalCheckup: formData.Electrical_checkup,

      remarks: formData.remarks,
      // price: formData.price,
      price: finalPrice,

      date: formData.date,
      time: formData.time,
      status: "pending",

      // Rebook
      useSameServitor: formData.useSameServitor,
      previousServitorId: formData.servitor_id,

      serviceId: serviceId || 1,
    };

    if (appliedCoupon) {
      finalOrderData.appliedCoupon = appliedCoupon;
      finalOrderData.discountValue = discountValue;
    }

    try {
      await axios.post(`${URL}/electrician`, finalOrderData);
      // const response = await axios.post(`${URL}/electrician`, finalOrderData);
      // console.log("Order placed successfully:", response.data);
      setShowForm(false);
      setShowSuccessPopup(true);
    } catch (error) {
      console.error("Error placing order:", error);
      alert(error?.response?.data?.message || "Failed to place order");
    } finally {
      setIsSubmitting(false);
    }
  };

  // === Coupon handling ===
  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) {
      setCouponError("Please enter a coupon code.");
      return;
    }
    setIsApplyingCoupon(true);
    setCouponError("");
    try {
      const res = await axios.post(`${URL}/usercoupon/apply`, {
        userId: user.Id,
        code: couponCode.trim(),
      });
      const { discountValue, code } = res.data;
      setAppliedCoupon(code);
      setDiscountValue(discountValue);
      setCouponError("");
    } catch (err) {
      setAppliedCoupon(null);
      setDiscountValue(0);
      setCouponError(
        err?.response?.data?.message || "Invalid or expired coupon."
      );
    } finally {
      setIsApplyingCoupon(false);
    }
  };

  const handleRemoveCoupon = async () => {
    // try {
    //   await axios.post(`${URL}/usercoupon/remove`, {
    //     userId: user.Id,
    //     code: appliedCoupon,
    //   });
    // } catch (err) {
    //   console.warn("Coupon removal failed (non-blocking):", err);
    // }
    setAppliedCoupon(null);
    setDiscountValue(0);
    setCouponCode("");
    setCouponError("");
  };

  const closePopup = () => {
    setShowSuccessPopup(false);
    onClose();
    onSubmit();
    navigate("/profile/orderhistory");
  };

  const closeBlockedPopup = () => {
    setShowBlockedPopup(false);
    onClose();
  };

  return (
    <>
      {showForm && (
        <div className="electricianorder-modal-backdrop">
          <div className="electricianorder-modal-content">
            <div className="electricianorder-modal-header">
              <h2 className="electricianorder-modal-title">
                {/* Order Details */}
                {t("electricianorderform.order_form.modal.title")}{" "}
                {/* CHANGED: Updated to new namespace */}
              </h2>
              <button
                className="electricianorder-modal-close"
                onClick={onClose}
                aria-label={t(
                  "electricianorderform.order_form.modal.close_button"
                )}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>

            <div className="electricianorder-modal-body">
              <div className="electricianorder-two-column-grid">
                <div className="electricianorder-modal-card">
                  <div className="electricianorder-card-body">
                    <h3 className="electricianorder-card-title">
                      <FontAwesomeIcon icon={faUser} />
                      {/* Customer Information */}
                      {t(
                        "electricianorderform.order_form.customer_information.title"
                      )}{" "}
                      {/* CHANGED: Updated to new namespace */}
                    </h3>
                    <div className="electricianorder-form-grid">
                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {/* Name */}
                          {t(
                            "electricianorderform.order_form.customer_information.labels.name"
                          )}{" "}
                          {/* CHANGED: Updated to new namespace */}
                        </label>
                        <input
                          type="text"
                          className="electricianorder-form-control"
                          value={`${user.FirstName} ${user.LastName}`}
                          readOnly
                        />
                      </div>
                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {/* Mobile */}
                          {t(
                            "electricianorderform.order_form.customer_information.labels.mobile"
                          )}{" "}
                          {/* CHANGED: Updated to new namespace */}
                        </label>
                        <input
                          type="text"
                          className="electricianorder-form-control"
                          value={`${orderData.mobile}`}
                          readOnly
                        />
                      </div>
                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {/* City */}
                          {t(
                            "electricianorderform.order_form.customer_information.labels.city"
                          )}{" "}
                          {/* CHANGED: Updated to new namespace */}
                        </label>
                        <select
                          className="electricianorder-form-control"
                          value={selectedDivisionId || ""}
                          onChange={handleDivisionChange}
                          onBlur={validate}
                          ref={divisionRef}
                          aria-invalid={Boolean(errors.city)}
                          aria-describedby={
                            errors.city ? "city-error" : undefined
                          }
                        >
                          {/* <option value="">
                             {t('electricianorderform.order_form.customer_information.labels.city_placeholder')}
                           </option> */}
                          {/* {Object.entries(t('electricianorderform.order_form.customer_information.city_options', { returnObjects: true })).map(([key, value]) => (
                             <option key={key} value={value}>{value}</option>
                           ))} */}
                          <option value="">
                            {t(
                              "plumberorderform.order_form.customer_information.labels.city_placeholder"
                            )}
                          </option>
                          {divisions.map((d) => (
                            <option key={d.Id} value={d.Id}>
                              {d.name}
                            </option>
                          ))}
                        </select>
                        {errors.city && (
                          <div id="city-error" className="field-error">
                            {errors.city}
                          </div>
                        )}
                      </div>

                      {/* Area */}
                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {t(
                            "electricianorderform.order_form.customer_information.labels.area",
                            "Area"
                          )}
                        </label>
                        <select
                          className="electricianorder-form-control"
                          value={selectedAreaId || ""}
                          onChange={handleAreaChange}
                          onBlur={validate}
                          disabled={!selectedDivisionId}
                          aria-invalid={Boolean(errors.area)}
                          aria-describedby={
                            errors.area ? "area-error" : undefined
                          }
                          ref={areaRef}
                        >
                          <option value="">
                            {!selectedDivisionId
                              ? t("Select City first")
                              : t("Select Area")}
                          </option>
                          {areas.map((a) => (
                            <option key={a.Id} value={a.Id}>
                              {a.name}
                            </option>
                          ))}
                        </select>

                        {errors.area && (
                          <div id="area-error" className="field-error">
                            {errors.area}
                          </div>
                        )}
                      </div>

                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {/* Address */}
                          {t(
                            "electricianorderform.order_form.customer_information.labels.address"
                          )}{" "}
                          {/* CHANGED: Updated to new namespace */}
                        </label>
                        <textarea
                          name="address"
                          className="electricianorder-form-control"
                          rows="3"
                          value={orderData.address}
                          onChange={handleAddressChange}
                          onBlur={validate}
                          aria-invalid={Boolean(errors.address)}
                          aria-describedby={
                            errors.address ? "address-error" : undefined
                          }
                          ref={addressRef}
                        />
                        {errors.address && (
                          <div id="address-error" className="field-error">
                            {errors.address}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="electricianorder-modal-card">
                  <div className="electricianorder-card-body">
                    <h3 className="electricianorder-card-title">
                      <FontAwesomeIcon icon={faCalendarAlt} />
                      {/* Booking Details */}
                      {t(
                        "electricianorderform.order_form.booking_details.title"
                      )}{" "}
                      {/* CHANGED: Updated to new namespace */}
                    </h3>
                    <div className="electricianorder-form-grid">
                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {/* Date */}
                          {t(
                            "electricianorderform.order_form.booking_details.labels.date"
                          )}{" "}
                          {/* CHANGED: Updated to new namespace */}
                        </label>
                        <input
                          type="text"
                          className="electricianorder-form-control"
                          value={formatDate(formData.date)}
                          readOnly
                        />
                      </div>
                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {/* Time */}
                          {t(
                            "electricianorderform.order_form.booking_details.labels.time"
                          )}{" "}
                          {/* CHANGED: Updated to new namespace */}
                        </label>
                        <input
                          type="text"
                          className="electricianorder-form-control"
                          value={formData.time}
                          readOnly
                        />
                      </div>
                      {/* {!user.penaltyReserved && penalty > 0 ? (
                        <>
                          <div className="electricianorder-form-group">
                            <label className="electricianorder-form-label">
                              {t(
                                "electricianorderform.order_form.booking_details.labels.base_price"
                              )}{" "}
                            </label>
                            <input
                              type="text"
                              className="electricianorder-form-control"
                              value={`${basePrice} tk`}
                              readOnly
                            />
                          </div>
                          <div className="electricianorder-form-group">
                            <label className="electricianorder-form-label">
                              {t(
                                "electricianorderform.order_form.booking_details.labels.penalty"
                              )}{" "}
                            </label>
                            <input
                              type="text"
                              className="electricianorder-form-control electricianorder-penalty-field"
                              value={`${penalty} tk`}
                              readOnly
                            />
                          </div>

                          <div className="electricianorder-form-group">
                            <label className="electricianorder-form-label">
                              {t(
                                "electricianorderform.order_form.booking_details.labels.total_price"
                              )}
                            </label>

                            {appliedCoupon ? (
                              <div className="electricianorder-price-discounted">
                                <div className="electricianorder-original-price">
                                  {user.penaltyReserved
                                    ? `${basePrice} tk`
                                    : `${basePrice + penalty} tk`}
                                </div>

                                <div className="electricianorder-final-price">
                                  <span className="discounted-price">
                                    {finalPrice} tk
                                  </span>
                                  <small className="discount-label">
                                    ({discountValue} tk off)
                                  </small>
                                </div>
                              </div>
                            ) : (
                              <input
                                type="text"
                                className="electricianorder-form-control electricianorder-total-price"
                                value={`${finalPrice} tk`}
                                readOnly
                              />
                            )}
                          </div>
                        </>
                      ) : (
                        // New design for dicount
                        <div className="electricianorder-form-group">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.order_form.booking_details.labels.total_price"
                            )}
                          </label>

                          {appliedCoupon ? (
                            <div className="electricianorder-price-discounted">
                              <div className="electricianorder-original-price">
                                {user.penaltyReserved
                                  ? `${basePrice} tk`
                                  : `${basePrice + penalty} tk`}
                              </div>

                              <div className="electricianorder-final-price">
                                <span className="discounted-price">
                                  {finalPrice} tk
                                </span>
                                <small className="discount-label">
                                  ({discountValue} tk off)
                                </small>
                              </div>
                            </div>
                          ) : (
                            <input
                              type="text"
                              className="electricianorder-form-control electricianorder-total-price"
                              value={`${finalPrice} tk`}
                              readOnly
                            />
                          )}
                        </div>
                      )} */}

                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {t("electricianorderform.order_form.booking_details.labels.total_price")}
                        </label>

                        {appliedCoupon ? (
                          <div className="electricianorder-price-discounted">
                            <div className="electricianorder-original-price">{basePrice} tk</div>

                            <div className="electricianorder-final-price">
                              <span className="discounted-price">{finalPrice} tk</span>
                              <small className="discount-label">({discountValue} tk off)</small>
                            </div>
                          </div>
                        ) : (
                          <input
                            type="text"
                            className="electricianorder-form-control electricianorder-total-price"
                            value={`${finalPrice} tk`}
                            readOnly
                          />
                        )}
                      </div>


                      {/* Coupon Code */}
                      <div className="electricianorder-form-group">
                        <label className="electricianorder-form-label">
                          {t(
                            "electricianorderform.order_form.booking_details.labels.coupon",
                            "Coupon Code"
                          )}
                        </label>

                        {appliedCoupon ? (
                          <div className="electricianorder-coupon-applied">
                            {/* <p>
                              ✅ Applied: <strong>{appliedCoupon}</strong>
                            </p> */}
                            <p>
                              ✅{" "}
                              {t(
                                "electricianorderform.coupon.applied",
                                "Applied"
                              )}
                              : <strong>{appliedCoupon}</strong>
                            </p>
                            <button
                              type="button"
                              // className="electricianorder-btn electricianorder-btn-outline"
                              className="electricianorder-btn-removecoupon"
                              onClick={handleRemoveCoupon}
                            >
                              {/* Remove */}
                              {t(
                                "electricianorderform.coupon.remove",
                                "Remove"
                              )}
                            </button>
                          </div>
                        ) : (
                          <div className="electricianorder-coupon-input-row">
                            <input
                              type="text"
                              value={couponCode}
                              onChange={(e) => setCouponCode(e.target.value)}
                              placeholder={t(
                                "electricianorderform.order_form.booking_details.labels.coupon_placeholder",
                                "Enter coupon"
                              )}
                              className="electricianorder-form-control"
                              disabled={isApplyingCoupon}
                            />
                            <button
                              type="button"
                              // className="electricianorder-btn electricianorder-btn-primary"
                              className="electricianorder-btn-applycoupon"
                              onClick={handleApplyCoupon}
                              disabled={isApplyingCoupon}
                            >
                              {/* {isApplyingCoupon ? "Applying..." : "Apply"} */}
                              {isApplyingCoupon
                                ? t(
                                    "electricianorderform.coupon.applying",
                                    "Applying..."
                                  )
                                : t(
                                    "electricianorderform.coupon.apply",
                                    "Apply"
                                  )}
                            </button>
                          </div>
                        )}

                        {/* {couponError && <div className="field-error">{couponError}</div>} */}

                        {couponError && (
                          <div className="field-error">
                            {t(
                              "electricianorderform.coupon.invalid",
                              couponError
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="electricianorder-modal-card">
                <div className="electricianorder-card-body">
                  <h3 className="electricianorder-card-title">
                    {/* Service Details */}
                    {t(
                      "electricianorderform.order_form.service_details.title"
                    )}{" "}
                    {/* CHANGED: Updated to new namespace */}
                  </h3>
                  <div className="electricianorder-services-section">
                    {/* Fan & Coil Services */}
                    <div className="electricianorder-service-category">
                      <h4 className="electricianorder-category-header">
                        <FontAwesomeIcon icon={faFan} />
                        {t(
                          "electricianorderform.order_form.service_details.categories.fans_coil.title",
                          "Fan Services"
                        )}
                      </h4>
                      <div className="electricianorder-services-grid">


                        {/* New Ceiling Fan Installation */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.order_form.service_details.categories.fans_coil.labels.new_ceiling_fan_installation",
                              "New Ceiling Fan Installation"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                            formData.new_ceiling_fan_installation > 0 ? "has-value" : ""
                          }`}
                          >
                            {formData.new_ceiling_fan_installation}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.new_ceiling_fan_installation === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>
                        
                        {/* Ceiling Fan Installation */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.ceiling_fan_installation",
                              "Ceiling Fan Installation"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.ceiling_fan_installation > 0
                                ? "has-value"
                                : ""
                            }`}
                          >
                            {formData.ceiling_fan_installation}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.ceiling_fan_installation === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>

                        {/* Ceiling Fan Uninstallation */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.ceiling_fan_uninstallation",
                              "Ceiling Fan Uninstallation"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.ceiling_fan_uninstallation > 0
                                ? "has-value"
                                : ""
                            }`}
                          >
                            {formData.ceiling_fan_uninstallation}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.ceiling_fan_uninstallation === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>

                        {/* Fan Coil New Winding */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.fan_coil_new_winding",
                              "Fan Coil New Winding"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.fan_coil_new_winding > 0
                                ? "has-value"
                                : ""
                            }`}
                          >
                            {formData.fan_coil_new_winding}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.fan_coil_new_winding === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>

                        {/* Fan Coil Repair */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.fan_coil_repair",
                              "Fan Coil Repair"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.fan_coil_repair > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.fan_coil_repair}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.fan_coil_repair === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>

                        {/* Capacitor Setup */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.capacitor_setup",
                              "Capacitor Setup"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.capacitor_setup > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.capacitor_setup}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.capacitor_setup === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Light & Exhaust */}
                    <div className="electricianorder-service-category">
                      <h4 className="electricianorder-category-header">
                        <FontAwesomeIcon icon={faLightbulb} />
                        {t(
                          "electricianorderform.order_form.service_details.categories.light_exhaust.title",
                          "Light & Exhaust Fan"
                        )}
                      </h4>
                      <div className="electricianorder-services-grid">
                        {/* Light Installation */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.light_installation",
                              "Light Installation"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.light_installation > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.light_installation}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.light_installation === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>

                        {/* Light Repair */}
                        {/* <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.light_repair",
                              "Light Repair"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.light_repair > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.light_repair}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.light_repair === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div> */}

                        {/* Exhaust Fan Installation */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.exhaust_fan_installation",
                              "Exhaust Fan Installation"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.exhaust_fan_installation > 0
                                ? "has-value"
                                : ""
                            }`}
                          >
                            {formData.exhaust_fan_installation}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.exhaust_fan_installation === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>

                        {/* Exhaust Fan Cleaning */}

                        {/* <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.exhaust_fan_cleaning",
                              "Exhaust Fan Cleaning"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.exhaust_fan_cleaning > 0
                                ? "has-value"
                                : ""
                            }`}
                          >
                            {formData.exhaust_fan_cleaning}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.exhaust_fan_cleaning === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div> */}

                      </div>
                    </div>

                    {/* Switch • Socket • Regulator */}
                    <div className="electricianorder-service-category">
                      <h4 className="electricianorder-category-header">
                        <FontAwesomeIcon icon={faServer} />
                        {t(
                          "electricianorderform.order_form.service_details.categories.switch_socket_regulator.title",
                          "Switch • Socket • Regulator"
                        )}
                      </h4>
                      <div className="electricianorder-services-grid">
                        {/* Switch Setup */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.switch_setup",
                              "Switch Setup"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.switch_setup > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.switch_setup}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.switch_setup === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>

                        {/* Socket Setup */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.socket_setup",
                              "Socket Setup"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.socket_setup > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.socket_setup}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.socket_setup === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>

                        {/* Regulator Setup */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.regulator_setup",
                              "Regulator Setup"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.regulator_setup > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.regulator_setup}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.regulator_setup === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Doorbell • Drilling • IPS */}
                    <div className="electricianorder-service-category">
                      <h4 className="electricianorder-category-header">
                        <FontAwesomeIcon icon={faWrench} />
                        {t(
                          "electricianorderform.order_form.service_details.categories.misc.title",
                          "Doorbell • Drilling • IPS"
                        )}
                      </h4>
                      <div className="electricianorder-services-grid">
                        {/* Doorbell Installation */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.doorbell_installation",
                              "Doorbell Installation"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.doorbell_installation > 0
                                ? "has-value"
                                : ""
                            }`}
                          >
                            {formData.doorbell_installation}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.doorbell_installation === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>

                        {/* Drill Hole Service */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.drill_hole_service",
                              "Drill Hole Service"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.drill_hole_service > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.drill_hole_service}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.drill_hole_service === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>

                        {/* IPS Installation (Existing Line) */}
                        {/* <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.ips_installation_existing_line",
                              "IPS Installation (Existing Line)"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.ips_installation_existing_line > 0
                                ? "has-value"
                                : ""
                            }`}
                          >
                            {formData.ips_installation_existing_line}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.ips_installation_existing_line === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div> */}

                        {/* IPS New Line Installation */}
                        {/* <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.ips_new_line_installation",
                              "IPS New Line Installation"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.ips_new_line_installation > 0
                                ? "has-value"
                                : ""
                            }`}
                          >
                            {formData.ips_new_line_installation}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.ips_new_line_installation === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div> */}
                        
                      </div>
                    </div>

                    {/* Wiring & Boards */}
                    <div className="electricianorder-service-category">
                      <h4 className="electricianorder-category-header">
                        <FontAwesomeIcon icon={faPlug} />
                        {t(
                          "electricianorderform.order_form.service_details.categories.wiring_boards.title",
                          "Wiring • Boards • Checkup"
                        )}
                      </h4>
                      <div className="electricianorder-services-grid">
                        {/* New Wiring Point */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.new_wiring_point",
                              "New Wiring Point"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.new_wiring_point > 0 ? "has-value" : ""
                            }`}
                          >
                            {formData.new_wiring_point}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.new_wiring_point === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>

                        {/* Main Circuit Board Setup */}
                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.service_labels.main_circuit_board_setup",
                              "Main Circuit Board Setup"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.main_circuit_board_setup > 0
                                ? "has-value"
                                : ""
                            }`}
                          >
                            {formData.main_circuit_board_setup}{" "}
                            <span className="electricianorder-service-unit">
                              {t(
                                formData.main_circuit_board_setup === 1
                                  ? "electricianorderform.order_form.service_details.unit"
                                  : "electricianorderform.order_form.service_details.units"
                              )}
                            </span>
                          </div>
                        </div>

                        <div className="electricianorder-service-item">
                          <label className="electricianorder-form-label">
                            {t(
                              "electricianorderform.order_form.service_details.categories.wiring_checkup.labels.electrical_checkup",
                              "Electrical Checkup"
                            )}
                          </label>
                          <div
                            className={`electricianorder-service-value ${
                              formData.Electrical_checkup ? "boolean-true" : ""
                            }`}
                          >
                            {t(
                              `electricianorderform.order_form.service_details.categories.wiring_checkup.boolean.${
                                formData.Electrical_checkup ? "yes" : "no"
                              }`
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Electrical Checkup */}
                    <div className="electricianorder-service-category">
                      <div className="electricianorder-services-grid">
                        {/* Rebook same servitor (unchanged) */}
                        {formData.useSameServitor && previousServitorName && (
                          <div className="electricianorder-service-item electricianorder-rebook-item">
                            <label className="electricianorder-form-label electricianorder-label-content">
                              <FontAwesomeIcon
                                icon={faCheckCircle}
                                className="electricianorder-rebook-icon"
                              />
                              {t(
                                "electricianorderform.order_form.rebook.label"
                              )}
                            </label>
                            <div className="electricianorder-service-value electricianorder-rebook-value">
                              <strong>{previousServitorName}</strong>
                            </div>
                          </div>
                        )}

                        {/* Remarks (unchanged) */}
                        {formData.remarks && (
                          <div className="electricianorder-service-item electricianorder-remarks-item">
                            <label className="electricianorder-form-label">
                              <FontAwesomeIcon
                                icon={faCommentAlt}
                                className="electricianorder-remarks-icon"
                              />
                              {t(
                                "electricianorderform.order_form.service_details.categories.wiring_checkup.labels.remarks"
                              )}
                            </label>
                            <div className="electricianorder-service-value has-value electricianorder-remarks-value">
                              {formData.remarks}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="electricianorder-order-actions">
              <button
                className="electricianorder-btn electricianorder-btn-outline"
                onClick={onClose}
              >
                {/* Cancel */}
                {t("electricianorderform.order_form.actions.cancel")}{" "}
                {/* CHANGED: Updated to new namespace */}
              </button>
              <button
                className="electricianorder-btn electricianorder-btn-primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                <FontAwesomeIcon icon={faTools} />
                {/* Place Order */}
                {/* {t("electricianorderform.order_form.actions.place_order")}{" "} */}

                {isSubmitting
                  ? t(
                      "electricianorderform.order_form.actions.placing",
                      "Placing..."
                    )
                  : t("electricianorderform.order_form.actions.place_order")}

              </button>
            </div>
          </div>
        </div>
      )}

      {/* Order Succesfully placed */}
      {showSuccessPopup && (
        <div className="electricianorder-success-popup">
          <div className="electricianorder-success-popup-content">
            <h2>
              {/* Order Successfully Placed! */}
              {t("electricianorderform.order_form.success_popup.title")}{" "}
              {/* CHANGED: Updated to new namespace */}
            </h2>
            <p>
              {/* Thank you for choosing HelpNao. */}
              {t("electricianorderform.order_form.success_popup.message1")}{" "}
              {/* CHANGED: Updated to new namespace */}
            </p>
            <p>
              {/* Your order is now pending confirmation. */}
              {t("electricianorderform.order_form.success_popup.message2")}{" "}
              {/* CHANGED: Updated to new namespace */}
            </p>
            <button
              className="electricianorder-btn electricianorder-btn-primary"
              onClick={closePopup}
            >
              {/* Ok */}
              {t("electricianorderform.order_form.success_popup.button")}{" "}
              {/* CHANGED: Updated to new namespace */}
            </button>
          </div>
        </div>
      )}

      {showBlockedPopup && (
        <div className="electricianorder-success-popup">
          <div className="electricianorder-success-popup-content">
            <h2>
              {/* Account Blocked */}
              {t("electricianorderform.order_form.blocked_popup.title")}{" "}
              {/* CHANGED: Updated to new namespace */}
            </h2>
            <p>
              {/* Your account is blocked due to excessive cancellations. */}
              {t("electricianorderform.order_form.blocked_popup.message1")}{" "}
              {/* CHANGED: Updated to new namespace */}
            </p>
            <p>
              {/* Please contact our support team for assistance. */}
              {t("electricianorderform.order_form.blocked_popup.message2")}{" "}
              {/* CHANGED: Updated to new namespace */}
            </p>
            <button
              className="electricianorder-btn electricianorder-btn-primary"
              onClick={closeBlockedPopup}
            >
              {/* Close */}
              {t("electricianorderform.order_form.blocked_popup.button")}{" "}
              {/* CHANGED: Updated to new namespace */}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ElectricianOrderForm;
